import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import { groupBy, uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import { soapApi } from "../../../../redux/actions/api";
import {
  addBillingItemsToPaymentId,
  addDirectBilling,
  getPetBillingByIdAllWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../../redux/reducers/loaderSlice";
import {
  createPrescriptionWoLoader,
  createProcedure,
  createProcedureWoLoader,
  deletePrescriptionItemByIdWoLoader,
  deleteProcedureByIdWoLoader,
  deleteProcedureDetailByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
  updateNoteByAppointmentIdWoLoader,
  updatePrescriptionByIdWoLoader,
  updateProcedureByIdWoLoader,
} from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  frequncyCheckList,
  reasonIssueList,
  reasonList,
} from "../../../../util/arrayList";
import { pharmacyStatusDrop, routeList } from "../../../../util/dropList";
import { billingTabEnum } from "../../../../util/enum";
import {
  datePlusOneDay,
  getDoneAtFromNextDueDate,
  getOnlyName,
  getProcedureDetails,
  getProcedureDetailsNew,
  getRightPackageUom,
} from "../../../../util/function";
import { refreshClinicStocksToSession } from "../../../../util/refreshClinicStocksToSession";
import { canWriteModule } from "../../../../util/roleModuleAccess";
import PointOfSaleNew from "../../ClinicPayments/PointOfSaleNew";
import PharmacyAddAdministerDrawer from "./Administer/PharmacyAddAdministerDrawer";
import PharmacyAdministerCard from "./Administer/PharmacyAdministerCard";
import PharmacyEditAdministerDrawer from "./Administer/PharmacyEditAdministerDrawer";
import PharmacyAddConsumablesDrawer from "./Consumables/PharmacyAddConsumablesDrawer";
import PharmacyConsumableCard from "./Consumables/PharmacyConsumableCard";
import PharmacyEditConsumableDrawer from "./Consumables/PharmacyEditConsumableDrawer";
import FilesWithCloseButton from "./FilesWithCloseButton";
import AddPrescriptionDrawer from "./Prescription/AddPrescriptionDrawer";
import EditPrescriptionDrawer from "./Prescription/EditPrescriptionDrawer";
import PharmacyPrescriptionCard from "./Prescription/PharmacyPrescriptionCard";

const initProced = { consumList: [], adminList: [], presList: [] };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const initOpenObj = { consum: true, admin: true, pres: true };
const cardSty = {
  borderRadius: 3,
  padding: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 0.5,
  marginRight: 0.5,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
};
const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };
const reqTxt = "This field is required";
const roundAmount = (value) => Number(Number(value ?? 0).toFixed(2));
const initPres = {
  name: null,
  dosage: "1",
  duration: "1",
  frequency: [],
  meal: "",
  customFrequency: false,
  route: routeList?.[0],
  plName: null,
};
const initFileValues = { modVsble: false, files: [], type: null };
const defObj = {
  services: [],
  stocks: [],
  locations: [],
  facilities: [],
  clinic: {},
};

const buildProcedureUpdatePayload = ({
  reqProced,
  reqServ,
  reqVar,
  reqDet,
  procedureDetails,
}) => {
  let tax = 0;
  let total = reqVar?.servicePrice ?? reqProced?.serviceCharge ?? 0;
  if ((reqServ?.taxApplicability ?? "")?.toLowerCase() === "yes") {
    tax +=
      (Number(reqVar?.servicePrice ?? 0) / 100) * Number(reqServ?.tax ?? 0);
    total += tax;
  }

  return {
    serviceCharge: reqProced?.serviceCharge,
    serviceType: reqProced?.serviceType,
    appointmentId: reqDet?.appointment?.appointmentId ?? reqDet?.appointmentId,
    procedureDetails,
    tax: Number(Number(tax) * Number(reqProced?.quantity ?? 1)),
    total: Number(Number(total) * Number(reqProced?.quantity ?? 1)),
    mrpPrice: Number(reqVar?.servicePrice ?? 0),
    procedureVariantId:
      reqVar?.variantId ?? reqProced?.procedureVariantId ?? null,
    quantity: Number(reqProced?.quantity ?? 1),
    hsnSacCode: reqServ?.hsnSacCode ?? null,
    paymentId: reqDet?.paymentId ?? null,
  };
};

const getProcedureGroupKey = (obj) =>
  obj?.procedureId ??
  `${obj?.serviceId ?? ""}:${obj?.variantId ?? obj?.procedureVariantId ?? ""}`;

const PetPharmacyProcedures = ({ onPosVisibleChange, onCreateBillReady }) => {
  const dispatch = useDispatch();
  const canManagePharmacy = canWriteModule("pharmacy");
  const location = useLocation();
  const [procedures, setProcedures] = useState([]);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [procedValues, setProcedValues] = useState(initProced);
  const [changeWarnVsble, setChangeWarnVsble] = useState(false);
  const [notesModVsble, setNotesModVsble] = useState(false);
  const [notes, setNotes] = useState("");
  const [adminValues, setAdminValues] = useState({});
  const [presValues, setPresValues] = useState({});
  const [consumValues, setConsumValues] = useState({});
  const [admStatusVsble, setAdmStatusVsble] = useState(false);
  const [presStatusVsble, setPresStatusVsble] = useState(false);
  const [admUpdteModVsble, setAdmUpdteModVsble] = useState(false);
  const [conStatusVsble, setConStatusVsble] = useState(false);
  const [fileValues, setFileValues] = useState(initFileValues);
  const [objOpen, setObjOpen] = useState(initOpenObj);
  const [selectedItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [dispensedBillItems, setDispensedBillItems] = useState([]);
  const [createBillModVsble, setCreateBillModVsble] = useState(false);
  const [selectedBillKeys, setSelectedBillKeys] = useState([]);
  const [posVisible, setPosVisible] = useState(false);
  const [selectedPayment, setSelecetdPayment] = useState(null);
  const [isAddPresDrawerOpen, setIsAddPresDrawerOpen] = useState(false);
  const [isEditPresDrawerOpen, setIsEditPresDrawerOpen] = useState(false);
  const [selectedPresItem, setSelectedPresItem] = useState(null);
  const [isAddConsumDrawerOpen, setIsAddConsumDrawerOpen] = useState(false);
  const [isEditConsumDrawerOpen, setIsEditConsumDrawerOpen] = useState(false);
  const [selectedConsumable, setSelectedConsumable] = useState(null);
  const [isAddAdminDrawerOpen, setIsAddAdminDrawerOpen] = useState(false);
  const [isEditAdminDrawerOpen, setIsEditAdminDrawerOpen] = useState(false);
  const [selectedAdminItem, setSelectedAdminItem] = useState(null);
  const { petBilling } = useSelector((state) => state?.clinic);
  const { appointment } = location.state || {};
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );
  const petDet = petAndApntData?.pet;
  const appDet = reqDet?.appointment;
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    services,
    stocks: clinicStocks,
    locations,
    facilities,
    clinic,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        locations: Array.isArray(reqData?.locations) ? reqData?.locations : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(
      getPetBillingByIdAllWoLoader({
        petId: appDet?.petId ?? appointment?.appoinment?.petId,
      }),
    );
    // dispatch(getLocations());
    // dispatch(getClinicFacilities());
  }, []);

  useEffect(() => {
    onPosVisibleChange?.(posVisible);
  }, [posVisible, onPosVisibleChange]);

  useEffect(() => {
    const reqPrceds = [];
    const reqCons = [];
    const reqAdms = [];
    const reqPresList = [];
    reqDet?.procedures?.forEach((prcd, i) => {
      const reqServ = services?.find(
        (ser) => ser?.serviceId === prcd?.serviceId,
      );
      const vnts = getVarinatList(prcd?.serviceId);
      const reqVnt =
        vnts?.find(
          (vnt) => String(vnt?.variantId) === String(prcd?.procedureVariantId),
        ) ??
        vnts?.find(
          (vnt) =>
            vnt?.serviceId === prcd?.serviceId &&
            vnt?.name === prcd?.serviceType,
        );
      const reqObj = {
        service: {
          name: reqServ?.serviceName,
          value: reqServ?.serviceName,
          serviceId: reqServ?.serviceId,
          category: reqServ?.category,
          subCategory: reqServ?.subCategory,
          remarks: reqServ?.description,
          procedureId: prcd?.procedureId,
        },
        variant: reqVnt,
        procedureId: prcd?.procedureId,
        i,
      };
      reqPrceds.push(reqObj);
      prcd?.procedureDetails
        ?.filter(
          (det) =>
            !(
              det?.status === "true" ||
              det?.status === "false" ||
              det?.status === null
            ) ||
            det?.status === "" ||
            det?.itemIssued === "true" ||
            det?.itemIssued === "false",
        )
        ?.forEach((det) => {
          const reqStock = clinicStocks?.find(
            (stc) => stc?.stockId === det?.stockId,
          );
          const reqBatc = reqStock?.stockBatch?.find(
            (bat) => bat?.batchId === det?.batchId,
          );
          const isRequested =
            det?.status === "requested" || det?.remarks === "Requested";
          const isIssued =
            det?.status === "issued" || det?.itemIssued === "true";
          const isRejected =
            det?.status === "rejected" || det?.itemIssued === "false";
          const comObj = {
            name:
              det?.name ?? reqStock?.productName ?? det?.procedureName ?? "",
            procedureName: det?.procedureName,
            stockId: det?.stockId,
            batchId: det?.batchId,
            quantity: det?.quantity,
            detailId: det?.detailId,
            active: det?.active,
            status:
              det?.status?.length > 0
                ? det?.status === "true"
                  ? true
                  : det?.status === "false"
                    ? false
                    : det?.status
                : null,
            itemIssued:
              det?.itemIssued?.length > 0 ? det?.itemIssued === "true" : null,
            isRejected,
            isRequested,
            isIssued,
            remarks: det?.remarks?.length > 0 ? det?.remarks : null,
            statusDrop:
              det?.status?.length > 0
                ? det?.status === "true"
                  ? pharmacyStatusDrop?.[0]
                  : pharmacyStatusDrop?.[1]
                : null,
            reason: det?.remarks?.length > 0 ? det?.remarks : null,
            estCost: det?.estimatedCost,
            delete: false,
            isEdit:
              det?.status === "true" || det?.status === "false"
                ? false
                : det?.itemIssued === "true" || det?.itemIssued === "false"
                  ? false
                  : true,
            deleteable: true,
            serviceId: prcd?.serviceId,
            procedureId: prcd?.procedureId,
            variantId: prcd?.procedureVariantId ?? reqVnt?.variantId,
            procedureVariantId: prcd?.procedureVariantId ?? reqVnt?.variantId,
            assignToProcedure: {
              name: reqServ?.serviceName,
              serviceId: prcd?.serviceId,
              value: reqServ?.serviceName,
              variantId: prcd?.procedureVariantId ?? reqVnt?.variantId,
              procedureId: prcd?.procedureId,
            },
            linkToProcedure: reqServ?.serviceName,
            batchNumber: {
              name: reqBatc?.batchNo ?? "Unknown",
              value: reqBatc?.batchId ?? null,
              batchId: reqBatc?.batchId ?? null,
              salesUom: reqBatc?.salesUom ?? null,
            },
          };
          if (det?.type === "Consumables") {
            reqCons.push(comObj);
          }
          if (det?.type === "Administered") {
            const reqAdmObj = {
              ...comObj,
              type: reqStock?.category,
              route: routeList?.find((rl) => rl?.name === det?.route),
              batchId: det?.batchId,
              duration: "1",
              vaccineType: det?.route,
              dosage: det?.dosage,
            };
            reqAdms.push(reqAdmObj);
          }
        });
    });
    reqDet?.prescription?.[0]?.prescriptionDetails?.forEach((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        frequency:
          li?.morning || li?.afternoon || li?.night
            ? [
                li?.morning && "morning",
                li?.afternoon && "afternoon",
                li?.night && "night",
              ]?.filter(Boolean)
            : [],
        customFrequency:
          !li?.morning &&
          !li?.afternoon &&
          !li?.night &&
          li?.frequencyDuration?.length > 0,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        itemIssued:
          li?.itemIssued?.length > 0 ? li?.itemIssued === "true" : null,
        itemIssuedStatus: li?.itemIssuedStatus,
        isEdit:
          li?.itemIssued === "true" || li?.itemIssued === "false"
            ? false
            : true,
        route: routeList?.find((rl) => rl?.name === li?.route) ?? null,
        remark: li?.remark ?? "",
      };
      if (
        Array.isArray(li?.frequencyDuration) &&
        li.frequencyDuration.length > 0
      ) {
        reqObj.frequency = li.frequencyDuration
          .map((freq) => frequncyCheckList?.find((f) => f?.apiValue === freq))
          ?.filter(Boolean);
      }
      reqPresList.push(reqObj);
    });
    setProcedures(reqPrceds);
    setProcedValues({
      ...procedValues,
      consumList:
        reqCons?.length > 0 ? reqCons?.map((cl, i) => ({ ...cl, i })) : [],
      adminList:
        reqAdms?.length > 0 ? reqAdms?.map((al, i) => ({ ...al, i })) : [],
      presList:
        reqPresList?.length > 0
          ? reqPresList?.map((pl, i) => ({ ...pl, i }))
          : [],
    });
  }, [reqDet?.procedures, reqDet?.prescription]);

  const onApiCall = () => {
    dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
  };

  const getStockById = (stkId) => {
    if (!stkId) return null;
    return clinicStocks?.find((stc) => stc?.stockId === stkId) ?? null;
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      // ?.filter((btch) => btch?.billlable === "Y")
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        packageUom: btch?.packageUom,
      }));
    return filteredBatches;
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getServiceList = () => {
    const reqServList = services
      ?.filter((sl) => sl?.category !== "Diagnostics")
      ?.map((ser) => ({
        name: ser?.serviceName,
        value: ser?.serviceName,
        serviceId: ser?.serviceId,
        category: ser?.category,
        subCategory: ser?.subCategory,
        remarks: ser?.description,
      }));
    const procedureIds = new Set(procedures?.map((p) => p?.service?.serviceId));
    const reqList = reqServList?.filter(
      (srv) => !procedureIds.has(srv?.serviceId),
    );
    return reqList;
  };

  const onChange = (name, value, ind, vrntId) => {
    const reqPrcdres = procedures?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "service") {
          reqObj.serviceId = value?.serviceId;
          const vrnts = getVarinatList(value?.serviceId);
          reqObj.variant = vrnts?.[0];
          reqObj.variantId = vrnts?.[0]?.variantId;
        }
        if (name === "variant") {
          reqObj.variantId = value?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedures(reqPrcdres);
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.filter(
        (vl) => vl?.createdBy === clinic?.id && vl?.approved,
      )
      ?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const delProcedure = (ind) => {
    const reqServ = procedures?.find((li) => li?.i === ind)?.service;
    if (reqServ?.procedureId) {
      if (
        procedValues?.consumList
          ?.filter((li) => li?.serviceId === reqServ?.serviceId)
          ?.some((li) => typeof li?.status === "boolean") ||
        procedValues?.adminList
          ?.filter((li) => li?.serviceId === reqServ?.serviceId)
          ?.some((li) => typeof li?.status === "boolean")
      ) {
        setSelectedProcedure({
          type: "delete",
          index: ind,
          serviceId: reqServ?.serviceId,
          procedureId: reqServ?.procedureId ?? null,
        });
        return setChangeWarnVsble(true);
      }
      dispatch(deleteProcedureByIdWoLoader(reqServ?.procedureId)).then(
        (res) => {
          if (res?.payload) onApiCall();
        },
      );
    }
  };

  const addPreventive = (itm) => {
    const reqSer = services?.find((li) => li?.serviceId === itm?.serviceId);
    const reqVnt = reqSer?.serviceVariants?.find(
      (li) => li?.variantId === itm?.variantId,
    );
    const data = {
      doneAt: moment(new Date(itm?.nextDueDate)).format("YYYY-MM-DD"),
      remarks: "",
      procedureDetails: [],
      serviceType: reqVnt?.variantName,
      isFromPreventive: true,
      procedureVariantId: reqVnt?.variantId ?? itm?.variantId,
      procedureName: itm?.linkToProcedure,
      serviceId: itm?.serviceId,
      category: reqSer?.category ?? "",
      subCategory: reqSer?.subCategory ?? "",
      petId: appDet?.petId,
      status: "Pending",
    };
    dispatch(createProcedure({ data }));
  };

  const onCloseFileMod = () => {
    setFileValues(initFileValues);
  };

  const getItemPrice = (stkId = null, batchId = null) => {
    let unitSellingPrice = 0;
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
    if (reqStock) {
      if (batchId) {
        return (
          reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId)
            ?.unitSellingPrice ?? 0
        );
      }
      return reqStock?.stockBatch?.[0]?.unitSellingPrice;
    }
    return unitSellingPrice;
  };

  const getUOMListByStockId = (stkId = null) => {
    if (!stkId) return [];
    const stockMat = clinicStocks?.find((stc) => stc?.stockId === stkId);
    return (
      stockMat?.uomMappings
        ?.filter((ml) => ml?.allowSale === "Y" && ml?.show)
        ?.map((ml) => ({
          name: ml?.unit,
          value: ml?.unit,
          conversion: ml?.conversion,
          uomMappingId: ml?.uomMappingId ?? null,
        })) ?? []
    );
  };

  const getStockBatches = (stkId = null) => {
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.filter((btch) => {
        const clinicMat = btch?.createdBy === clinicDet?.id;
        const isQty = btch?.quantity > 0;
        const locat = locations?.find((loc) => loc?.id === btch?.locationId);
        const isPharLoc = (locat?.category ?? "")?.toLowerCase() === "pharmacy";
        return btch?.approved && clinicMat && isQty && isPharLoc;
      }) ?? []
    );
  };

  const fetchProcedureDetailsNew = async (servId, varntId) =>
    getProcedureDetailsNew({
      servId,
      varntId,
      services: services ?? [],
      clinicStocks: clinicStocks ?? [],
      pharmacyTaxId: clinicDet?.pharmacyTaxId,
      status: true,
      facilities,
      facilityId: appDet?.facilityId,
      patientWorkbook: true,
      locations: locations ?? [],
      clinicId: clinicDet?.id,
    });

  const resolveProcedureForItem = (obj) => {
    if (obj?.procedureId) {
      const byId = reqDet?.procedures?.find(
        (pl) => String(pl?.procedureId) === String(obj?.procedureId),
      );
      if (byId) return byId;
    }
    const variantId = obj?.variantId ?? obj?.procedureVariantId;
    if (obj?.serviceId && variantId) {
      const byServiceVariant = reqDet?.procedures?.find(
        (pl) =>
          String(pl?.serviceId) === String(obj?.serviceId) &&
          String(pl?.procedureVariantId) === String(variantId),
      );
      if (byServiceVariant) return byServiceVariant;
    }
    return reqDet?.procedures?.find(
      (pl) => String(pl?.serviceId) === String(obj?.serviceId),
    );
  };

  const resolveVariantForProcedure = (reqServ, reqProced, obj) => {
    const variantId =
      obj?.variantId ??
      obj?.procedureVariantId ??
      reqProced?.procedureVariantId;
    return (
      reqServ?.serviceVariants?.find(
        (vnt) => String(vnt?.variantId) === String(variantId),
      ) ?? null
    );
  };

  const buildAdminProcedureDetail = (obj, reqServ, reqVar) => {
    const isRequest =
      obj?.status === "requested" || obj?.reason === "Requested";
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === obj?.stockId);
    const isLinked = !!obj?.serviceId;
    const isNoAmount =
      reqStock?.autoConsumed || !reqStock?.billable || isLinked;
    const batchId = obj?.batchId ?? obj?.batchNumber?.value ?? null;
    const clinicBatches = getStockBatches(obj?.stockId);
    const reqBat = isRequest
      ? null
      : batchId
        ? (clinicBatches?.find((bat) => bat?.batchId === batchId) ??
          getBatch(obj?.stockId, batchId) ??
          clinicBatches?.[0])
        : clinicBatches?.[0];
    const currLocat = locations?.find((loc) => loc?.id === reqBat?.locationId);
    const reqUnitPrice = isNoAmount
      ? 0
      : (reqBat?.unitSellingPrice ?? obj?.unitSellingPrice ?? 0);
    const taxPerent =
      reqServ?.taxApplicability?.toLowerCase() === "yes"
        ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        : 0;
    const reqPercent = 100 + Number(taxPerent);
    const quantity = Number(obj?.quantity ?? 1);
    const reqPrice = isNoAmount
      ? 0
      : Number(obj?.estCost ?? reqUnitPrice * quantity);
    const unitPrice = Number(reqPrice) / (reqPercent / 100);
    const prdTaxValue = (taxPerent / 100) * Number(unitPrice);
    const nextDueDate =
      isLinked &&
      reqStock?.category?.toLowerCase() === "vaccines" &&
      reqServ?.nextDueDate?.length > 0
        ? getDoneAtFromNextDueDate(reqServ?.nextDueDate)
        : (obj?.nextDueDate ?? null);
    const uomList = getUOMListByStockId(obj?.stockId);
    const defaultUom =
      uomList?.find(
        (ul) => ul?.uomMappingId === obj?.uomId || ul?.value === obj?.uomName,
      ) ?? uomList?.[0];

    return {
      detailId: obj?.detailId ?? null,
      stockId: obj?.stockId ?? null,
      batchId: isRequest
        ? null
        : (batchId ?? (reqStock?.autoConsumed ? reqBat?.batchId : null)),
      type: "Administered",
      quantity,
      status: obj?.status,
      remarks: obj?.reason,
      estimatedCost: reqPrice,
      name: obj?.procedureName ?? obj?.name,
      procedureName: obj?.procedureName ?? obj?.name,
      dosage: obj?.dosage,
      route: obj?.route?.value ?? obj?.route ?? null,
      isDelete: false,
      serviceId: obj?.serviceId,
      itemIssued: obj?.itemIssued ?? null,
      itemIssuedStatus: obj?.itemIssuedStatus ?? null,
      tax: isNoAmount ? 0 : Number(prdTaxValue ?? 0),
      total: isNoAmount ? 0 : Number(reqPrice ?? 0),
      mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
      procedureVariantId:
        reqVar?.variantId ?? obj?.variantId ?? obj?.procedureVariantId ?? null,
      patientWorkbook: true,
      mainProcedure: false,
      drugSchedule: reqServ?.drugSchedule ?? null,
      hsnSacCode: reqServ?.hsnSacCode ?? null,
      packageUom: reqBat?.salesUom ?? obj?.salesUom ?? null,
      expiryDate: reqBat?.expiryDate ?? null,
      batchNo:
        obj?.batchNumber?.name || reqBat?.batchNo || obj?.batchNo || null,
      billable: reqStock?.billable,
      autoConsumed: reqStock?.autoConsumed,
      linked: isLinked ? "Y" : "N",
      billType: reqStock?.autoConsumed
        ? currLocat?.category
          ? billingTabEnum?.[currLocat?.category]
          : "treatment"
        : "treatment",
      nextDueDate,
      billSeparated: !!obj?.billedSeparately,
      uomId: defaultUom?.uomMappingId ?? obj?.uomId ?? null,
      uomName: defaultUom?.value ?? obj?.uomName ?? null,
      billing: true,
    };
  };

  const addUpdateAdminItems = (objOrList) => {
    const items = (Array.isArray(objOrList) ? objOrList : [objOrList])?.filter(
      (obj) => obj?.procedureId || obj?.serviceId,
    );
    if (!items?.length) return;

    const grouped = groupBy(items, getProcedureGroupKey);
    const groupKeys = Object.keys(grouped);

    groupKeys?.forEach((key, i) => {
      const groupItems = grouped?.[key] ?? [];
      const reqProced = resolveProcedureForItem(groupItems?.[0]);
      if (!reqProced?.procedureId) return;
      const reqServ = services?.find(
        (ser) =>
          ser?.serviceId ===
          (reqProced?.serviceId ?? groupItems?.[0]?.serviceId),
      );
      const reqVar = resolveVariantForProcedure(
        reqServ,
        reqProced,
        groupItems?.[0],
      );
      const reqProcedureDetails = groupItems?.map((obj) =>
        buildAdminProcedureDetail(obj, reqServ, reqVar),
      );
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: buildProcedureUpdatePayload({
            reqProced,
            reqServ,
            reqVar,
            reqDet,
            procedureDetails: reqProcedureDetails,
          }),
        }),
      ).then((res) => {
        if (res?.payload) {
          if (groupKeys?.length === i + 1) {
            refreshClinicStocksToSession(dispatch);
            onApiCall();
            onCloseFileMod();
          }
        }
      });
    });
  };

  const handleEditProcedure = (ind) => {
    const reqList = procedures?.map((li, i) => {
      if (i === ind) {
        return {
          ...li,
          editable: true,
          prevServId: li?.service?.serviceId,
          prevVarntId: li?.variant?.variantId,
          procedureId: li?.procedureId ?? li?.service?.procedureId ?? null,
        };
      }
      return li;
    });
    setProcedures(reqList);
  };

  const onAddNotes = () => {
    setNotes(appDet?.notes ?? "");
    setNotesModVsble(true);
  };

  const handleAddNewPres = () => {
    setIsAddPresDrawerOpen(true);
  };

  const handleOpenEditPresDrawer = (item) => {
    setSelectedPresItem(item);
    setIsEditPresDrawerOpen(true);
  };

  const handleDispensePresItem = (item) => {
    handleChangePresValue("itemIssued", true, item?.i);
  };

  const getReqFacility = () => {
    return (
      facilities?.find((fac) => fac?.facilityId === appDet?.facilityId) ?? null
    );
  };

  const getRequiredBatch = (batchList) => {
    if (!batchList) return null;
    const primLocMat = batchList?.find(
      (bat) => bat?.locationId === getReqFacility()?.primaryStorage,
    );
    if (primLocMat) return primLocMat;
    const secLocMat = batchList?.find(
      (bat) => bat?.locationId === getReqFacility()?.secondaryStorage,
    );
    if (primLocMat) return secLocMat;
    if (role !== "ROLE_DOCTOR") return batchList?.[0];
    return {
      batchNo: "Unknown",
      batchId: null,
      name: "Unknown",
      value: null,
      subunits: null,
      quantity: null,
      locationId: null,
      locationName: "",
    };
  };

  const onChangeAdminValue = (name, value, ind, addObj) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (!li?.dosage && addObj?.stockId) {
            const batchList = clinicStocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch;
            const reqBatch =
              batchList?.length > 0
                ? (getRequiredBatch(batchList) ?? null)
                : null;
            if (reqBatch?.dosage?.length > 0) {
              reqObj.dosage = reqBatch?.dosage;

              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio =
                Number(reqBatch?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.batchId = null; // reqBatch?.batchId;
              reqObj.estCost = reqPrice;
            }
            reqObj.batchNumber = null;
            //  {
            //   name: reqBatch?.batchNo,
            //   value: reqBatch?.batchId,
            // };
          }
          if (li?.dosage) {
            if (addObj?.stockId) {
              const stckBatches = clinicStocks?.find(
                (stc) => stc?.stockId === addObj?.stockId,
              )?.stockBatch;
              const reqBatch = stckBatches?.find(
                (bat) =>
                  bat?.batchId ===
                  (addObj?.batchId ??
                    reqObj?.batchNumber?.value ??
                    reqObj?.batchId),
              );
              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.batchId = null; //reqBatch?.batchId;
              reqObj.estCost = reqPrice;
              reqObj.batchNumber = null;
              //  {
              //   name: reqBatch?.batchNo,
              //   value: reqBatch?.batchId,
              // };
            }
          }
          // if (!reqObj?.detailId) {
          //   reqObj.status = null;
          //   reqObj.reason = "";
          //   addUpdateAdminItems(reqObj);
          // }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value ?? li?.batchId);
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.estCost = value?.value ? reqPrice : 0;
          reqObj.batchId = value?.value ?? null;
          reqObj.batchNo = value?.name ?? null;
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "Issued";
            reqObj.status = "issued";
            if (
              li?.type?.toLowerCase() === "flea & tick treatment" ||
              li?.type?.toLowerCase() === "vaccines" ||
              li?.type?.toLowerCase() === "deworming"
            ) {
              setAdminValues({
                ...li,
                status: "issued",
                reason: "Issued",
                statusDrop: value,
                nextDueDate: datePlusOneDay,
              });
              setAdmUpdteModVsble(true);
            } else {
              addUpdateAdminItems(reqObj);
            }
          } else {
            setAdminValues({ reason: reasonList?.[0]?.value, i: ind });
            setAdmStatusVsble(true);
          }
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "";
            reqObj.status = "issued";
            reqObj.reason = "";
            reqObj.batchId =
              reqObj?.batchNumber?.value ??
              li?.batchNumber?.value ??
              li?.batchId;
            addUpdateAdminItems(reqObj);
          } else {
            setAdminValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setAdmStatusVsble(true);
          }
        }
        if (name === "dosage") {
          const reqBatch = getBatch(
            li?.stockId,
            li?.batchNumber?.value ?? li?.batchId,
          );
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio = Number(value) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.estCost = reqPrice;
        }
        if (name === "quantity") {
          reqObj.qtyErr = Number(value) > 0 ? false : true;
        }
        if (name === "linkToProcedure") {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
          reqObj.procedureId = addObj?.procedureId ?? li?.procedureId;
          reqObj.procedureVariantId =
            addObj?.variantId ?? addObj?.procedureVariantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
  };

  const getBatches = (stkId = null) => {
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
    const clinicBatches = reqStock?.stockBatch?.filter((btch) => {
      const clinicMat = btch?.createdBy === clinicDet?.id;
      const isQty = btch?.quantity > 0;
      const locat = locations?.find((loc) => loc?.id === btch?.locationId);
      const isPharLoc = (locat?.category ?? "")?.toLowerCase() === "pharmacy";
      return btch?.approved && clinicMat && isQty && isPharLoc;
    });
    return clinicBatches?.length > 0
      ? clinicBatches?.map((bat) => {
          const reqLocation = locations?.find(
            (loc) => loc?.id === bat?.locationId,
          );
          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
          };
        })
      : [
          {
            name: "Unknown",
            value: null,
            subunits: null,
            quantity: null,
            locationId: null,
            locationName: "",
          },
        ];
  };

  const hasItemBatchId = (li) => {
    const batchId = li?.batchNumber?.value ?? li?.batchId ?? null;
    if (batchId) return true;
    return !!getBatch(li?.stockId, null, true)?.autoConsumed;
  };

  const isPendingIssueItem = (li) =>
    !li?.isDelete &&
    li?.isEdit !== false &&
    typeof li?.itemIssued !== "boolean";

  const canIssueAllConsums = (procedValues?.consumList ?? [])?.some(
    (li) => isPendingIssueItem(li) && hasItemBatchId(li),
  );

  const canIssueAllAdmins = (procedValues?.adminList ?? [])?.some(
    (li) => isPendingIssueItem(li) && hasItemBatchId(li),
  );

  const deletePresDetailById = (id) => {
    dispatch(deletePrescriptionItemByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseDelMod();
      }
    });
  };

  const deletePresByIndex = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "presDetail" });
            setDelModVsble(true);
            // deletePresDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const buildConsumProcedureDetail = (obj, reqServ, reqVar) => {
    const isRequest =
      obj?.status === "requested" || obj?.reason === "Requested";
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === obj?.stockId);
    const isLinked = !!obj?.serviceId;
    const isNoAmount =
      reqStock?.autoConsumed || !reqStock?.billable || isLinked;
    const batchId = obj?.batchId ?? obj?.batchNumber?.value ?? null;
    const clinicBatches = getStockBatches(obj?.stockId);
    const reqBat = isRequest
      ? null
      : batchId
        ? (clinicBatches?.find((bat) => bat?.batchId === batchId) ??
          getBatch(obj?.stockId, batchId) ??
          clinicBatches?.[0])
        : clinicBatches?.[0];
    const currLocat = locations?.find((loc) => loc?.id === reqBat?.locationId);
    const reqUnitPrice = isNoAmount
      ? 0
      : (reqBat?.unitSellingPrice ?? obj?.unitSellingPrice ?? 0);
    const taxPerent =
      reqServ?.taxApplicability?.toLowerCase() === "yes"
        ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        : 0;
    const reqPercent = 100 + Number(taxPerent);
    const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
    const prdTaxValue = (taxPerent / 100) * Number(unitPrice);
    const uomList = getUOMListByStockId(obj?.stockId);
    const defaultUom =
      uomList?.find(
        (ul) => ul?.uomMappingId === obj?.uomId || ul?.value === obj?.uomName,
      ) ?? uomList?.[0];
    const quantity = Number(obj?.quantity ?? 1);
    const estimatedCost = isNoAmount
      ? 0
      : Number(obj?.estCost ?? reqUnitPrice * quantity);

    return {
      detailId: obj?.detailId ?? null,
      stockId: obj?.stockId ?? null,
      batchId: isRequest ? null : batchId,
      type: "Consumables",
      quantity,
      status: obj?.status,
      remarks: obj?.reason,
      estimatedCost,
      name: obj?.procedureName ?? obj?.name,
      procedureName: obj?.procedureName ?? obj?.name,
      isDelete: false,
      serviceId: obj?.serviceId ?? null,
      itemIssued: obj?.itemIssued ?? null,
      itemIssuedStatus: obj?.itemIssuedStatus ?? null,
      tax: isNoAmount ? 0 : Number(prdTaxValue ?? 0) * quantity,
      total: isNoAmount ? 0 : estimatedCost,
      mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
      procedureVariantId:
        reqVar?.variantId ?? obj?.variantId ?? obj?.procedureVariantId ?? null,
      patientWorkbook: true,
      mainProcedure: false,
      drugSchedule: reqServ?.drugSchedule ?? null,
      hsnSacCode: reqServ?.hsnSacCode ?? null,
      packageUom: reqBat?.salesUom ?? obj?.salesUom ?? null,
      expiryDate: reqBat?.expiryDate ?? null,
      batchNo:
        obj?.batchNumber?.name || reqBat?.batchNo || obj?.batchNo || null,
      billable: reqStock?.billable,
      autoConsumed: reqStock?.autoConsumed,
      linked: isLinked ? "Y" : "N",
      billType: reqStock?.autoConsumed
        ? currLocat?.category
          ? billingTabEnum?.[currLocat?.category]
          : "treatment"
        : "treatment",
      billSeparated: !!obj?.billedSeparately,
      uomId: defaultUom?.uomMappingId ?? obj?.uomId ?? null,
      uomName: defaultUom?.value ?? obj?.uomName ?? null,
      billing: true,
    };
  };

  const addUpdateConsumItems = (objOrList) => {
    const items = (Array.isArray(objOrList) ? objOrList : [objOrList])?.filter(
      (obj) => obj?.procedureId || obj?.serviceId,
    );
    if (!items?.length) return;

    const grouped = groupBy(items, getProcedureGroupKey);
    const groupKeys = Object.keys(grouped);

    groupKeys?.forEach((key, i) => {
      const groupItems = grouped?.[key] ?? [];
      const reqProced = resolveProcedureForItem(groupItems?.[0]);
      if (!reqProced?.procedureId) return;
      const reqServ = services?.find(
        (ser) =>
          ser?.serviceId ===
          (reqProced?.serviceId ?? groupItems?.[0]?.serviceId),
      );
      const reqVar = resolveVariantForProcedure(
        reqServ,
        reqProced,
        groupItems?.[0],
      );
      const reqProcedureDetails = groupItems?.map((obj) =>
        buildConsumProcedureDetail(obj, reqServ, reqVar),
      );
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: buildProcedureUpdatePayload({
            reqProced,
            reqServ,
            reqVar,
            reqDet,
            procedureDetails: reqProcedureDetails,
          }),
        }),
      ).then((res) => {
        if (res?.payload) {
          if (groupKeys?.length === i + 1) {
            refreshClinicStocksToSession(dispatch);
            onApiCall();
            onCloseFileMod();
          }
        }
      });
    });
  };

  const onIssueAllConsums = () => {
    const pendingWithBatch = (procedValues?.consumList ?? [])?.filter(
      (li) => !li?.isDelete && li?.isEdit && hasItemBatchId(li),
    );
    if (!pendingWithBatch?.length) return;

    const hasInvalid = pendingWithBatch?.some(
      (li) =>
        !li?.name ||
        (typeof li?.name === "string" && !li?.name?.trim?.()) ||
        !li?.quantity ||
        Number(li?.quantity) <= 0,
    );
    if (hasInvalid) {
      const reqList = procedValues?.consumList?.map((li) => {
        if (li?.isDelete || !li?.isEdit || !hasItemBatchId(li)) return li;
        return {
          ...li,
          nameErr:
            !li?.name || (typeof li?.name === "string" && !li?.name?.trim?.()),
          qtyErr: !li?.quantity || Number(li?.quantity) <= 0,
        };
      });
      setProcedValues({ ...procedValues, consumList: reqList });
      return;
    }

    const itemsToIssue = pendingWithBatch?.map((li) => ({
      ...li,
      itemIssuedStatus: "",
      status: "issued",
      reason: "",
      batchId: li?.batchNumber?.value ?? li?.batchId,
      itemIssued: true,
    }));
    if (!itemsToIssue?.length) return;

    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.isDelete || !li?.isEdit || !hasItemBatchId(li)) return li;
      return {
        ...li,
        itemIssuedStatus: "",
        status: "issued",
        reason: "",
        batchId: li?.batchNumber?.value ?? li?.batchId,
        itemIssued: true,
        isEdit: false,
      };
    });
    setProcedValues({ ...procedValues, consumList: reqList });
    addUpdateConsumItems(itemsToIssue);
  };

  const onIssueAllAdmins = () => {
    const pendingWithBatch = (procedValues?.adminList ?? [])?.filter(
      (li) => !li?.isDelete && li?.isEdit && hasItemBatchId(li),
    );
    if (!pendingWithBatch?.length) return;

    const hasInvalid = pendingWithBatch?.some(
      (li) =>
        !li?.name ||
        (typeof li?.name === "string" && !li?.name?.trim?.()) ||
        !li?.quantity ||
        Number(li?.quantity) <= 0,
    );
    if (hasInvalid) {
      const reqList = procedValues?.adminList?.map((li) => {
        if (li?.isDelete || !li?.isEdit || !hasItemBatchId(li)) return li;
        return {
          ...li,
          nameErr:
            !li?.name || (typeof li?.name === "string" && !li?.name?.trim?.()),
          qtyErr: !li?.quantity || Number(li?.quantity) <= 0,
        };
      });
      setProcedValues({ ...procedValues, adminList: reqList });
      return;
    }

    const itemsToIssue = pendingWithBatch?.map((li) => ({
      ...li,
      itemIssuedStatus: "",
      status: "issued",
      reason: "",
      batchId: li?.batchNumber?.value ?? li?.batchId,
      itemIssued: true,
    }));
    if (!itemsToIssue?.length) return;

    const reqList = procedValues?.adminList?.map((li) => {
      if (li?.isDelete || !li?.isEdit || !hasItemBatchId(li)) return li;
      return {
        ...li,
        itemIssuedStatus: "",
        status: "issued",
        reason: "",
        batchId: li?.batchNumber?.value ?? li?.batchId,
        itemIssued: true,
        isEdit: false,
      };
    });
    setProcedValues({ ...procedValues, adminList: reqList });
    addUpdateAdminItems(itemsToIssue);
  };

  const onChangeConsumValue = (name, value, ind, addObj) => {
    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name" && addObj) {
          reqObj.stockId = addObj?.stockId ?? li?.stockId;
          reqObj.batchId = addObj?.batchId ?? li?.batchId;
          reqObj.serviceId = addObj?.serviceId ?? li?.serviceId;
          reqObj.category = addObj?.category ?? li?.category;
          if (addObj?.stockId ?? li?.stockId) {
            const reqBatch = addObj?.batchId
              ? getBatch(
                  addObj?.stockId ?? li?.stockId,
                  addObj?.batchId ?? li?.batchId,
                )
              : clinicStocks?.find(
                  (stc) => stc?.stockId === addObj?.stockId ?? li?.stockId,
                )?.stockBatch?.[0];
            reqObj.batchId = null; //reqBatch?.batchId;
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.estCost = reqCost;
          }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value ?? li?.batchId);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) *
            Number(li?.quantity ?? 1);
          reqObj.estCost = value?.value ? reqPrice : 0;
          reqObj.batchId = value?.value ?? null;
          reqObj.batchNo = value?.name ?? null;
        }
        if (name === "quantity") {
          reqObj.qtyErr = Number(value) > 0 ? false : true;
          const price = getItemPrice(li?.stockId ?? null, li?.batchId ?? null);
          reqObj.estCost = Number(price) * Number(value ?? 1);
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "";
            addUpdateConsumItems(reqObj);
          } else {
            setConsumValues({ reason: reasonList?.[0]?.value, i: ind });
            setConStatusVsble(true);
          }
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "";
            reqObj.status = "issued";
            reqObj.reason = "";
            reqObj.batchId =
              reqObj?.batchNumber?.value ??
              li?.batchNumber?.value ??
              li?.batchId;
            addUpdateConsumItems(reqObj);
          } else {
            setConsumValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setConStatusVsble(true);
          }
        }
        if (name === "linkToProcedure") {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
          reqObj.procedureId = addObj?.procedureId ?? li?.procedureId;
          reqObj.procedureVariantId =
            addObj?.variantId ?? addObj?.procedureVariantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues({ ...procedValues, consumList: reqList });
  };

  const handleChangePresValue = (name, value, ind, addObj) => {
    let shouldDispense = false;
    const reqList = procedValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "plName" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = clinicStocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch?.[0];
            reqObj.batchId = reqBatch?.batchId;
            reqObj.dosage = reqBatch?.dosage;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "itemIssued") {
          if (value) {
            reqObj.itemIssuedStatus = "Completed";
            reqObj.itemIssued = true;
            shouldDispense = true;
          } else {
            setPresValues({
              itemIssuedStatus: reasonIssueList?.[0]?.value,
              i: ind,
            });
            setPresStatusVsble(true);
          }
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setProcedValues({ ...procedValues, presList: reqList });
    if (shouldDispense) {
      const dispensedItem = reqList?.[ind];
      if (dispensedItem) {
        setDispensedBillItems((prev) => {
          const key = dispensedItem?.detailId ?? dispensedItem?.i;
          if (prev?.some((li) => (li?.detailId ?? li?.i) === key)) {
            return prev;
          }
          return [...(prev ?? []), { ...dispensedItem, itemIssued: true }];
        });
      }
      addUpdatePresItems(reqList?.filter((li) => !li?.isDelete));
    }
  };

  const handleObjOpen = (name, value) => {
    setObjOpen({ ...objOpen, [name]: value });
  };

  const onAddFiles = (type) => {
    setFileValues({ ...fileValues, modVsble: true, type });
  };

  const getDropList = (li) => {
    const list = [
      {
        name: li?.name,
        value: li?.name,
        stockId: li?.stockId,
        batchId: li?.batchId,
      },
    ];
    if (li?.alternates?.length > 0) {
      li?.alternates?.forEach((al) => {
        list.push({
          name: al?.name,
          value: al?.name,
          stockId: al?.stockId,
          batchId: al?.batchId,
        });
      });
    }
    return uniqBy(list, "stockId");
  };

  const getList = (isPres = false) => {
    const categories = isPres
      ? [
          "deworming",
          "diet",
          "flea & tick treatment",
          "fluid therapy",
          "grooming & hygiene care",
          "medication",
          "nutrition and supplements",
          "other parasite treatment",
          "vaccines",
        ]
      : [
          "general consumables",
          "medical supplies",
          "surgical supplies",
          "lab consumables",
          "lab supplies",
          "cleaning supplies",
          "grooming & hygiene care",
          "fluid therapy",
          "mortuary",
        ];

    return (clinicStocks ?? [])
      ?.filter(
        (dta) =>
          dta?.active === "Y" &&
          categories.includes((dta?.category ?? "").toLowerCase()),
      )
      ?.map((li) => {
        const clinicbatches = li?.stockBatch?.filter(
          (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
        );
        const totalQty = (clinicbatches ?? [])?.reduce(
          (acc, obj) => acc + (obj?.quantity ?? 0),
          0,
        );
        return {
          name: li?.tradeName ?? li?.productName,
          value: li?.tradeName ?? li?.productName,
          stockId: li?.stockId,
          type: li?.category,
          productName: li?.productName,
          tradeName: li?.tradeName,
          totalQty,
        };
      });
  };

  const getPresList = () => {
    const categories = [
      "medication",
      "diet",
      "nutrition and supplements",
      "fluid therapy",
      "other parasite treatment",
      "deworming",
      "flea & tick treatment",
      "grooming & hygiene care",
    ];

    return (clinicStocks ?? [])
      ?.filter(
        (dta) =>
          dta?.active === "Y" &&
          dta?.billable &&
          categories.includes((dta?.category ?? "").toLowerCase()),
      )
      ?.map((li) => {
        const clinicbatches = li?.stockBatch?.filter(
          (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
        );
        const totalQty = (clinicbatches ?? [])?.reduce(
          (acc, obj) => acc + (obj?.quantity ?? 0),
          0,
        );
        const isNearExpiry = (clinicbatches ?? [])?.some((batch) => {
          const expiryDate = batch?.expiryDate;
          if (!expiryDate?.length) return false;
          const today = moment().startOf("day");
          const expiry = moment(new Date(expiryDate)).startOf("day");
          if (expiry.isBefore(today)) return false;
          return expiry.diff(today, "days") < 30;
        });
        return {
          name: li?.tradeName ?? li?.productName,
          value: li?.tradeName ?? li?.productName,
          stockId: li?.stockId,
          type: li?.category,
          productName: li?.productName,
          tradeName: li?.tradeName,
          totalQty,
          isNearExpiry,
        };
      });
  };

  const deleteMultipleDetailIds = (ids = []) => {
    ids?.forEach((id) => {
      dispatch(deleteProcedureDetailByIdWoLoader(id));
    });
  };

  const createUpdateProcedure = (prcd) => {
    if (
      !(prcd?.serviceId ?? prcd?.service?.serviceId) ||
      !(prcd?.variantId ?? prcd?.variant?.variantId)
    ) {
      return;
    }
    if (!prcd?.service?.procedureId && !prcd?.prevServId) {
      const procedureDetails = getProcedureDetails(
        prcd?.serviceId ?? prcd?.service?.serviceId,
        prcd?.variantId ?? prcd?.variant?.variantId,
        prcd?.service?.name,
        services ?? [],
        clinicStocks ?? [],
        clinicDet?.pharmacyTaxId,
      )?.procedureDetails;
      if (
        getProcedureDetails(
          prcd?.serviceId ?? prcd?.service?.serviceId,
          prcd?.variantId ?? prcd?.variant?.variantId,
          prcd?.service?.name,
          services ?? [],
          clinicStocks ?? [],
          clinicDet?.pharmacyTaxId,
        )?.prescriptions?.length > 0
      ) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: getProcedureDetails(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
            prcd?.service?.name,
            services ?? [],
            clinicStocks ?? [],
            clinicDet?.pharmacyTaxId,
          )?.prescriptions,
          issue: "",
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            }),
          );
        } else {
          dispatch(
            createPrescriptionWoLoader({
              appointmentId: appDet?.appointmentId,
              data,
            }),
          );
        }
      }

      const data = {
        procedureName: prcd?.service?.name,
        serviceId: prcd?.service?.serviceId,
        category: prcd?.service?.category,
        subCategory: prcd?.service?.subCategory,
        remarks: prcd?.service?.remarks,
        doneAt: moment(new Date()).format("YYYY-MM-DD"),
        status: "Pending",
        petId: appDet?.petId,
        appointmentId: appDet?.appointmentId,
        serviceCharge: prcd?.variant?.serviceCharge,
        serviceType: getOnlyName(prcd?.variant?.name),
        procedureDetails,
      };
      dispatch(createProcedureWoLoader({ data })).then((res) => {
        if (res?.payload) onApiCall();
      });
    } else {
      if (
        procedValues?.consumList?.some(
          (cl) => typeof cl?.status === "boolean",
        ) ||
        procedValues?.adminList?.some((cl) => typeof cl?.status === "boolean")
      ) {
        setSelectedProcedure({ ...prcd, type: "variantChange" });
        return setChangeWarnVsble(true);
      } else {
        if (prcd?.service?.serviceId === prcd?.prevServId) {
          const prevCosumIds = procedValues?.consumList
            ?.filter(
              (cl) =>
                cl?.serviceId === prcd?.prevServId &&
                cl?.variantId === prcd?.prevVarntId,
            )
            ?.map((cl) => {
              return cl?.detailId;
            });
          const prevAdmIds = procedValues?.adminList
            ?.filter(
              (al) =>
                al?.serviceId === prcd?.prevServId &&
                al?.variantId === prcd?.prevVarntId,
            )
            ?.map((al) => {
              return al?.detailId;
            });
          // for deleting the prev
          deleteMultipleDetailIds([
            ...(prevCosumIds ?? []),
            ...(prevAdmIds ?? []),
          ]);
          fetchProcedureDetailsNew(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
          ).then((procedureDetailsResult) => {
            const procedureDetails = procedureDetailsResult?.procedureDetails;
            if (procedureDetailsResult?.prescriptions?.length > 0) {
              const presData = {
                status: "Pending",
                remark: "",
                prescription: procedureDetailsResult?.prescriptions,
                issue: "",
              };
              if (reqDet?.prescription?.[0]?.prescriptionId) {
                dispatch(
                  updatePrescriptionByIdWoLoader({
                    prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                    data: presData,
                  }),
                );
              } else {
                dispatch(
                  createPrescriptionWoLoader({
                    appointmentId: appDet?.appointmentId,
                    data: presData,
                  }),
                );
              }
            }
            const reqServ = services?.find(
              (ser) =>
                ser?.serviceId ===
                (prcd?.serviceId ?? prcd?.service?.serviceId),
            );
            const reqVar = reqServ?.serviceVariants?.find(
              (vnt) =>
                String(vnt?.variantId) ===
                String(prcd?.variantId ?? prcd?.variant?.variantId),
            );
            const data = {
              procedureName: prcd?.service?.name,
              serviceId: prcd?.service?.serviceId,
              category: prcd?.service?.category,
              subCategory: prcd?.service?.subCategory,
              remarks: prcd?.service?.remarks,
              doneAt: moment(new Date()).format("YYYY-MM-DD"),
              status: "Pending",
              petId: appDet?.petId,
              procedureDetails,
              ...buildProcedureUpdatePayload({
                reqProced: {
                  serviceCharge: prcd?.variant?.serviceCharge,
                  serviceType: getOnlyName(prcd?.variant?.name),
                  quantity: prcd?.qty ?? 1,
                  procedureVariantId:
                    prcd?.variantId ?? prcd?.variant?.variantId,
                },
                reqServ: reqServ ?? prcd?.service,
                reqVar: reqVar ?? prcd?.variant,
                reqDet,
                procedureDetails,
              }),
            };
            dispatch(
              updateProcedureByIdWoLoader({
                id: prcd?.service?.procedureId,
                data,
              }),
            ).then((res) => {
              if (res?.payload) onApiCall();
            });
          });
        } else {
          if (prcd?.procedureId) {
            dispatch(deleteProcedureByIdWoLoader(prcd?.procedureId));
          }
          const procedureDetails = getProcedureDetails(
            prcd?.serviceId ?? prcd?.service?.serviceId,
            prcd?.variantId ?? prcd?.variant?.variantId,
            prcd?.service?.name,
            services ?? [],
            clinicStocks ?? [],
            clinicDet?.pharmacyTaxId,
          ).procedureDetails;
          if (
            getProcedureDetails(
              prcd?.serviceId ?? prcd?.service?.serviceId,
              prcd?.variantId ?? prcd?.variant?.variantId,
              prcd?.service?.name,
              services ?? [],
              clinicStocks ?? [],
              clinicDet?.pharmacyTaxId,
            )?.prescriptions?.length > 0
          ) {
            const data = {
              status: "Pending",
              remark: "",
              prescription: getProcedureDetails(
                prcd?.serviceId ?? prcd?.service?.serviceId,
                prcd?.variantId ?? prcd?.variant?.variantId,
                prcd?.service?.name,
                services ?? [],
                clinicStocks ?? [],
                clinicDet?.pharmacyTaxId,
              )?.prescriptions,
              issue: "",
            };
            if (reqDet?.prescription?.[0]?.prescriptionId) {
              dispatch(
                updatePrescriptionByIdWoLoader({
                  prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                  data,
                }),
              );
            } else {
              dispatch(
                createPrescriptionWoLoader({
                  appointmentId: appDet?.appointmentId,
                  data,
                }),
              );
            }
          }
          const data = {
            procedureName: prcd?.service?.name,
            serviceId: prcd?.service?.serviceId,
            category: prcd?.service?.category,
            subCategory: prcd?.service?.subCategory,
            remarks: prcd?.service?.remarks,
            doneAt: moment(new Date()).format("YYYY-MM-DD"),
            status: "Pending",
            petId: appDet?.petId,
            appointmentId: appDet?.appointmentId,
            serviceCharge: prcd?.variant?.serviceCharge,
            serviceType: getOnlyName(prcd?.variant?.name),
            procedureDetails,
          };
          dispatch(createProcedureWoLoader({ data })).then((res) => {
            if (res?.payload) onApiCall();
          });
        }
      }
    }
  };

  const deleteProcedureDetailById = (id) => {
    dispatch(deleteProcedureDetailByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
      }
    });
  };

  const handleConsumDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "procedureDetail" });
            setDelModVsble(true);
            // deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const getProcedureListAsDrop = () => {
    if (procedures?.length === 0 || !procedures) return [];
    const reqProcedures = procedures
      ?.filter?.((li) => li?.service?.serviceId && li?.variant?.variantId)
      ?.map((prcd) => {
        return {
          name: prcd?.service?.name,
          value: prcd?.service?.name,
          serviceId: prcd?.service?.serviceId,
          varinatName: prcd?.variant?.name,
          variantId: prcd?.variant?.variantId,
          procedureId: prcd?.procedureId ?? prcd?.service?.procedureId ?? null,
        };
      });
    return reqProcedures;
  };

  const addProcedure = () => {
    const reqList = [...procedures];
    reqList.push({
      i: procedures?.length,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      editable: true,
    });
    setProcedures(reqList);
  };

  const addNewConsumable = () => {
    setIsAddConsumDrawerOpen(true);
  };

  const addNewAdminister = () => {
    setIsAddAdminDrawerOpen(true);
  };

  const getProcedureMetaForListItem = (li) => {
    const procedure = reqDet?.procedures?.find(
      (p) => p?.serviceId === li?.serviceId,
    );
    return procedure
      ? { procedureName: procedure?.serviceType ?? li?.linkToProcedure }
      : { procedureName: li?.linkToProcedure };
  };

  const mapConsumListItemForCard = (li) => ({
    ...li,
    procedureName: li?.name ?? li?.procedureName,
    estimatedCost: li?.estCost ?? 0,
    linked: li?.serviceId ? "Y" : "N",
    procedure: getProcedureMetaForListItem(li),
  });

  const mapAdminListItemForCard = (li) => ({
    ...li,
    procedureName: li?.name ?? li?.procedureName,
    estimatedCost: li?.estCost ?? 0,
    linked: li?.serviceId ? "Y" : "N",
    procedure: getProcedureMetaForListItem(li),
  });

  const getConsumableDetailFromReqDet = (detailId) => {
    if (!detailId) return null;
    for (const procedure of reqDet?.procedures ?? []) {
      const detail = procedure?.procedureDetails?.find(
        (d) => String(d?.detailId) === String(detailId),
      );
      if (detail?.type === "Consumables") {
        return { ...detail, procedure };
      }
    }
    return null;
  };

  const getAdministerDetailFromReqDet = (detailId) => {
    if (!detailId) return null;
    for (const procedure of reqDet?.procedures ?? []) {
      const detail = procedure?.procedureDetails?.find(
        (d) => String(d?.detailId) === String(detailId),
      );
      if (detail?.type === "Administered") {
        return { ...detail, procedure };
      }
    }
    return null;
  };

  const handleOpenEditConsumDrawer = (item) => {
    const fromApi = getConsumableDetailFromReqDet(item?.detailId);
    if (fromApi) {
      setSelectedConsumable(fromApi);
      setIsEditConsumDrawerOpen(true);
    }
  };

  const handleOpenEditAdminDrawer = (item) => {
    const fromApi = getAdministerDetailFromReqDet(item?.detailId);
    if (fromApi) {
      setSelectedAdminItem(fromApi);
      setIsEditAdminDrawerOpen(true);
    }
  };

  const handleIssueConsumItem = (item) => {
    onChangeConsumValue("itemIssued", true, item?.i);
  };

  const handleRejectConsumItem = (item) => {
    onChangeConsumValue("itemIssued", null, item?.i);
  };

  const handleIssueAdminItem = (item) => {
    onChangeAdminValue("itemIssued", true, item?.i);
  };

  const handleRejectAdminItem = (item) => {
    onChangeAdminValue("itemIssued", null, item?.i);
  };

  const handleConsumEdit = (ind) => {
    const item = procedValues?.consumList?.find((li) => li?.i === ind);
    if (item) handleOpenEditConsumDrawer(item);
  };

  const handleAdminDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const handleAdminEdit = (ind) => {
    const item = procedValues?.adminList?.find((li) => li?.i === ind);
    if (item) handleOpenEditAdminDrawer(item);
  };

  const buildPresDetail = (pre) => {
    const selStock = clinicStocks?.find((stc) => stc?.stockId === pre?.stockId);
    const btchDet = selStock?.stockBatch?.[0];
    const qty = typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty);
    const reqObj = {
      administered: false,
      type: pre?.type ?? null,
      stockId: pre?.stockId,
      batchId: btchDet?.batchId ?? null,
      name: pre?.plName,
      dosage: pre?.dosage,
      duration: pre?.duration,
      route: pre?.route?.value ?? pre?.route?.name ?? null,
      meal: pre?.meal,
      quantity: qty,
      subUnit: "Unit",
      morning:
        (pre?.frequency?.includes("morning") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      afternoon:
        (pre?.frequency?.includes("afternoon") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      night:
        (pre?.frequency?.includes("night") &&
          !pre?.frequency?.includes("Custom")) ??
        false,
      adminChargeAmount: 0,
      adminCharge: "N",
      percentage: false,
      delete: false,
      discontinued: "N",
      detailId: pre?.detailId ?? null,
      itemIssued: pre?.itemIssued ?? null,
      itemIssuedStatus: pre?.itemIssuedStatus ?? null,
      remark: pre?.remark ?? "",
    };
    const taxPercent =
      (btchDet?.cgst ? Number(btchDet?.cgst) : 0) +
      (btchDet?.sgst ? Number(btchDet?.sgst) : 0);
    const reqPercent = 100 + Number(taxPercent);
    const unitPrice =
      (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) /
      (reqPercent / 100);
    const taxValue =
      Number(
        (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) -
          Number(unitPrice),
      ) ?? 0;
    reqObj.price = unitPrice ?? 0;
    reqObj.mrpPrice = btchDet?.unitSellingPrice
      ? Number(btchDet?.unitSellingPrice)
      : 0;
    reqObj.mrpDiscount = 0;
    reqObj.tax = Number(taxValue) * Number(qty);
    reqObj.total =
      (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) *
        Number(qty) ?? 0;
    if (typeof pre?.frequency === "string") {
      reqObj.frequencyDuration = pre?.frequency;
    }
    if (pre?.productId) reqObj.productId = pre?.productId;
    if (pre?.serviceId) reqObj.serviceId = pre?.serviceId;
    return reqObj;
  };

  const addUpdatePresItems = (preOrList) => {
    const items = (
      Array.isArray(preOrList) ? preOrList : preOrList ? [preOrList] : []
    )?.filter(
      (pre) =>
        !(
          pre?.plName === "" ||
          pre?.plName === null ||
          pre?.plName === undefined
        ),
    );
    if (!items?.length) return;

    const data = {
      status: "Pending",
      remark: "",
      prescription: items?.map((pre) => buildPresDetail(pre)),
      issue: "",
    };
    if (reqDet?.prescription?.[0]?.prescriptionId) {
      dispatch(
        updatePrescriptionByIdWoLoader({
          prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          refreshClinicStocksToSession(dispatch);
          onApiCall();
        }
      });
    } else {
      dispatch(
        createPrescriptionWoLoader({
          appointmentId: appDet?.appointmentId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          refreshClinicStocksToSession(dispatch);
          onApiCall();
        }
      });
    }
  };

  const onDispenseAllPres = () => {
    const hasInvalid = (procedValues?.presList ?? [])
      ?.filter((li) => !li?.isDelete && li?.isEdit)
      ?.some(
        (li) =>
          !li?.plName ||
          (typeof li?.plName === "string" && !li?.plName?.trim?.()),
      );
    if (hasInvalid) {
      const reqList = procedValues?.presList?.map((li) => {
        if (li?.isDelete || !li?.isEdit) return li;
        return {
          ...li,
          nameErr:
            !li?.plName ||
            (typeof li?.plName === "string" && !li?.plName?.trim?.()),
        };
      });
      setProcedValues({ ...procedValues, presList: reqList });
      return;
    }

    const itemsToDispense = (procedValues?.presList ?? [])
      ?.filter((li) => !li?.isDelete && li?.isEdit)
      ?.map((li) => ({
        ...li,
        itemIssuedStatus: "Completed",
        itemIssued: true,
      }));
    if (!itemsToDispense?.length) return;

    setDispensedBillItems((prev) => {
      const merged = [...(prev ?? [])];
      itemsToDispense?.forEach((item) => {
        const key = item?.detailId ?? item?.i;
        if (!merged?.some((li) => (li?.detailId ?? li?.i) === key)) {
          merged.push({ ...item, itemIssued: true });
        }
      });
      return merged;
    });

    const reqList = procedValues?.presList?.map((li) => {
      if (li?.isDelete || !li?.isEdit) return li;
      return {
        ...li,
        itemIssuedStatus: "Completed",
        itemIssued: true,
        isEdit: false,
      };
    });
    setProcedValues({ ...procedValues, presList: reqList });
    addUpdatePresItems(reqList?.filter((li) => !li?.isDelete));
  };

  const handleEditPresItem = (ind) => {
    const item = procedValues?.presList?.find((pl) => pl?.i === ind);
    if (item) handleOpenEditPresDrawer(item);
  };

  const onCloseConMod = () => {
    setConStatusVsble(false);
    setConsumValues({});
  };

  const onCloseAdmUpdteMod = () => {
    setAdmUpdteModVsble(false);
    setAdminValues({});
  };

  const onChangeAdminStatusValue = (name, value) => {
    setAdminValues({ ...adminValues, [name]: value });
  };

  const onChangeConStatusValue = (name, value) => {
    setConsumValues({ ...consumValues, [name]: value });
  };

  const onChangePresStatusValue = (name, value) => {
    setPresValues({ ...presValues, [name]: value });
  };

  const handleSaveConsumStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList?.map((li, i) => {
      if (li?.i === consumValues?.i) {
        const reqObj = {
          ...li,
          itemIssuedStatus: consumValues?.itemIssuedStatus,
          // reason: consumValues?.reason
          // status: false,
          itemIssued: false,
          status: "rejected",
          reason: consumValues?.itemIssuedStatus,
        };
        addUpdateConsumItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseConMod();
  };

  const handleSaveAdminStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        const reqObj = {
          ...li,
          status: "rejected",
          reason: adminValues?.itemIssuedStatus,
          itemIssuedStatus: adminValues?.itemIssuedStatus,
          itemIssued: false,
          nextDosage: adminValues?.nextDosage,
          nextDueDate: adminValues?.nextDueDate,
        };
        addUpdateAdminItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmMod();
  };

  const handleSavePresStatus = () => {
    const reqList = procedValues?.presList?.map((li) => {
      if (li?.i === presValues?.i) {
        return {
          ...li,
          itemIssuedStatus: presValues?.itemIssuedStatus,
          itemIssued: false,
        };
      }
      return li;
    });
    setProcedValues({ ...procedValues, presList: reqList });
    addUpdatePresItems(reqList?.filter((li) => !li?.isDelete));
    onClosePresMod();
  };

  const onCloseAdmMod = () => {
    setAdmStatusVsble(false);
    setAdminValues({});
  };

  const onClosePresMod = () => {
    setPresStatusVsble(false);
    setPresValues({});
  };

  const onCloseNoteMod = () => {
    setNotesModVsble(false);
    setNotes("");
  };

  const onSaveNotes = () => {
    dispatch(
      updateNoteByAppointmentIdWoLoader({
        id: appDet?.appointmentId,
        note: notes,
        remarks: appDet?.remarks,
      }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseNoteMod();
      }
    });
  };

  const onSaveAdminValues = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        addUpdateAdminItems({
          ...adminValues,
          status: adminValues?.itemIssued ? "issued" : "rejected",
          reason: adminValues?.itemIssued ? "" : adminValues?.itemIssuedStatus,
          itemIssued: adminValues?.itemIssued ? true : false,
          itemIssuedStatus: adminValues?.itemIssued
            ? ""
            : adminValues?.itemIssuedStatus,
        });
        return { ...adminValues, isEdit: false };
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmUpdteMod();
  };

  const onChangeAdminModValue = (name, value, addObj) => {
    const reqObj = { ...adminValues, [name]: value };
    if (name === "name" && addObj) {
      reqObj.type = addObj?.type;
      reqObj.stockId = addObj?.stockId;
      if (!adminValues?.dosage && addObj?.stockId) {
        const reqBatch = clinicStocks?.find(
          (stc) => stc?.stockId === addObj?.stockId,
        )?.stockBatch?.[0];
        reqObj.batchNumber = {
          name: reqBatch?.batchNo,
          value: reqBatch?.batchId,
        };
      }
      if (adminValues?.dosage) {
        if (addObj?.stockId) {
          const reqBatch = clinicStocks?.find(
            (stc) => stc?.stockId === addObj?.stockId,
          )?.stockBatch?.[0];
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio =
            Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.batchId = reqBatch?.batchId;
          reqObj.estCost = reqPrice;
          reqObj.batchNumber = {
            name: reqBatch?.batchNo,
            value: reqBatch?.batchId,
          };
        }
      }
    }
    if (name === "batchNumber") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        value?.value ?? adminValues?.batchId,
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio =
        Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = value?.value ? reqPrice : 0;
    }
    if (name === "status") {
      if (value) {
        reqObj.reason = "Completed";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "statusDrop") {
      reqObj.status = value;
      if (value) {
        reqObj.reason = "";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "itemIssued") {
      reqObj.itemIssuedStatus = value;
      if (value) {
        reqObj.itemIssuedStatus = "";
      } else {
        reqObj.itemIssuedStatus = reasonList?.[0]?.value;
      }
    }
    if (name === "dosage") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        adminValues?.batchNumber?.value ?? adminValues?.batchId,
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio = Number(value) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = reqPrice;
    }
    if (name === "linkToProcedure") {
      reqObj.serviceId = addObj?.serviceId;
      reqObj.variantId = addObj?.variantId;
      reqObj.procedureId = addObj?.procedureId ?? reqObj?.procedureId;
      reqObj.procedureVariantId =
        addObj?.variantId ?? addObj?.procedureVariantId;
    }
    setAdminValues(reqObj);
  };

  const handleAdmImageRemove = (ind) => {
    const reqFiles = (adminValues?.files ?? [])?.filter((fl, i) => i !== ind);
    setAdminValues({ ...adminValues, files: reqFiles });
  };

  const onUploadAdmFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      adminValues?.files?.length > 0 ? [...adminValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setAdminValues({ ...adminValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onFilesApiCall = async () => {
    if (fileValues?.files?.length === 0 || !fileValues?.files) return;
    dispatch(showLoader());
    const formData = new FormData();
    fileValues?.files?.forEach((file) => {
      formData.append("files", file?.file);
    });
    const res = await soapApi.post("/vaccination", formData);
    if (res?.status === 200) {
      const reqStock = clinicStocks?.filter(
        (li) =>
          li?.tradeName?.toLowerCase() ===
            (res?.data?.TradeName || "").toLowerCase() &&
          li?.stockBatch?.some(
            (bat) =>
              bat?.batchNo?.toLowerCase() ===
              (res?.data?.BatchNumber || "").toLowerCase(),
          ),
      );
      const reqBatch = reqStock?.stockBatch?.find(
        (bat) =>
          bat?.batchNo?.toLowerCase() === res?.data?.BatchNumber?.toLowerCase(),
      );
      const reqObj = {
        name: res?.data?.Name ?? res?.data?.TradeName,
        quantity: 1,
        reason: null,
        deleteable: true,
        isEdit: true,
        estCost: reqStock?.unitSellingPrice ?? 0,
        status: null,
        delete: false,
        serviceId: procedures?.[0]?.service?.serviceId ?? null,
        variantId: procedures?.[0]?.variant?.variantId ?? null,
        procedureId:
          procedures?.[0]?.procedureId ??
          procedures?.[0]?.service?.procedureId ??
          null,
        procedureVariantId: procedures?.[0]?.variant?.variantId ?? null,
        linkToProcedure: procedures?.[0]?.service?.name ?? null,
        stockId: reqStock?.stockId ?? null,
        batchId: reqBatch?.batchId ?? null,
        detailId: null,
        dosage: "1",
        route: null,
        isDelete: false,
      };
      if (fileValues?.type === "consumables") {
        addUpdateConsumItems(reqObj);
      }
      if (fileValues?.type === "administer") {
        addUpdateAdminItems(reqObj);
      }
      dispatch(hideLoader());
    } else {
      dispatch(hideLoader());
    }
  };

  const handleRemoveFile = (ind) => {
    const reqFiles = (fileValues?.files ?? [])
      ?.filter((fl, i) => i !== ind)
      ?.map((li, i) => ({ ...li, i }));
    setFileValues({ ...fileValues, files: reqFiles });
  };

  const onUploadFiles = (e) => {
    const fileList = e?.target?.files;
    let fileLists = fileValues?.files?.length > 0 ? [...fileValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setFileValues({ ...fileValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onCloseChangeWarnMod = () => {
    setChangeWarnVsble(false);
    setSelectedProcedure(null);
  };

  const onConfirmChangeWarn = () => {
    let reqData = {};
    if (selectedProcedure?.type === "delete") {
      if (selectedProcedure?.procedureId) {
        dispatch(
          deleteProcedureByIdWoLoader(selectedProcedure?.procedureId),
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
            return;
          }
        });
      }
      reqData.consumList = procedValues?.consumList
        ?.reduce((acc, item) => {
          if (item?.serviceId === selectedProcedure?.serviceId) {
            if (item?.detailId != null || item?.detailId !== undefined) {
              acc.push({ ...item, isDelete: true });
            }
          } else {
            acc.push(item);
          }
          return acc;
        }, [])
        ?.map((cl, i) => ({ ...cl, i }));
      reqData.adminList = procedValues?.adminList
        ?.reduce((acc, item) => {
          if (item?.serviceId === selectedProcedure?.serviceId) {
            if (item?.detailId != null || item?.detailId !== undefined) {
              acc.push({ ...item, isDelete: true });
            }
          } else {
            acc.push(item);
          }
          return acc;
        }, [])
        ?.map((al, i) => ({ ...al, i }));
    } else {
      if (
        selectedProcedure?.service?.serviceId === selectedProcedure?.prevServId
      ) {
        const prevCosumIds = procedValues?.consumList
          ?.filter(
            (cl) =>
              cl?.serviceId === selectedProcedure?.prevServId &&
              cl?.variantId === selectedProcedure?.prevVarntId,
          )
          ?.map((cl) => {
            return cl?.detailId;
          });
        const prevAdmIds = procedValues?.adminList
          ?.filter(
            (al) =>
              al?.serviceId === selectedProcedure?.prevServId &&
              al?.variantId === selectedProcedure?.prevVarntId,
          )
          ?.map((al) => {
            return al?.detailId;
          });
        // for deleting the prev
        deleteMultipleDetailIds([
          ...(prevCosumIds ?? []),
          ...(prevAdmIds ?? []),
        ]);
        fetchProcedureDetailsNew(
          selectedProcedure?.serviceId ?? selectedProcedure?.service?.serviceId,
          selectedProcedure?.variantId ?? selectedProcedure?.variant?.variantId,
        ).then((procedureDetailsResult) => {
          const procedureDetails = procedureDetailsResult?.procedureDetails;
          if (procedureDetailsResult?.prescriptions?.length > 0) {
            const presData = {
              status: "Pending",
              remark: "",
              prescription: procedureDetailsResult?.prescriptions,
              issue: "",
            };
            if (reqDet?.prescription?.[0]?.prescriptionId) {
              dispatch(
                updatePrescriptionByIdWoLoader({
                  prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                  data: presData,
                }),
              );
            } else {
              dispatch(
                createPrescriptionWoLoader({
                  appointmentId: appDet?.appointmentId,
                  data: presData,
                }),
              );
            }
          }
          const reqServ = services?.find(
            (ser) =>
              ser?.serviceId ===
              (selectedProcedure?.serviceId ??
                selectedProcedure?.service?.serviceId),
          );
          const reqVar = reqServ?.serviceVariants?.find(
            (vnt) =>
              String(vnt?.variantId) ===
              String(
                selectedProcedure?.variantId ??
                  selectedProcedure?.variant?.variantId,
              ),
          );
          const data = {
            procedureName: selectedProcedure?.service?.name,
            serviceId: selectedProcedure?.service?.serviceId,
            category: selectedProcedure?.service?.category,
            subCategory: selectedProcedure?.service?.subCategory,
            remarks: selectedProcedure?.service?.remarks,
            doneAt: moment(new Date()).format("YYYY-MM-DD"),
            status: "Pending",
            petId: appDet?.petId,
            procedureDetails,
            ...buildProcedureUpdatePayload({
              reqProced: {
                serviceCharge: selectedProcedure?.variant?.serviceCharge,
                serviceType: getOnlyName(selectedProcedure?.variant?.name),
                quantity: selectedProcedure?.qty ?? 1,
                procedureVariantId:
                  selectedProcedure?.variantId ??
                  selectedProcedure?.variant?.variantId,
              },
              reqServ: reqServ ?? selectedProcedure?.service,
              reqVar: reqVar ?? selectedProcedure?.variant,
              reqDet,
              procedureDetails,
            }),
          };
          dispatch(
            updateProcedureByIdWoLoader({
              id:
                selectedProcedure?.procedureId ??
                selectedProcedure?.service?.procedureId,
              data,
            }),
          ).then((res) => {
            if (res?.payload) {
              onApiCall();
              onCloseChangeWarnMod();
            }
          });
        });
      } else {
        if (
          selectedProcedure?.procedureId ??
          selectedProcedure?.service?.procedureId
        ) {
          dispatch(
            deleteProcedureByIdWoLoader(
              selectedProcedure?.procedureId ??
                selectedProcedure?.service?.procedureId,
            ),
          );
        }
        const procedureDetails = getProcedureDetails(
          selectedProcedure?.serviceId ?? selectedProcedure?.service?.serviceId,
          selectedProcedure?.variantId ?? selectedProcedure?.variant?.variantId,
          selectedProcedure?.service?.name,
          services ?? [],
          clinicStocks ?? [],
          clinicDet?.pharmacyTaxId,
        )?.procedureDetails;
        if (
          getProcedureDetails(
            selectedProcedure?.serviceId ??
              selectedProcedure?.service?.serviceId,
            selectedProcedure?.variantId ??
              selectedProcedure?.variant?.variantId,
            selectedProcedure?.service?.name,
            services ?? [],
            clinicStocks ?? [],
            clinicDet?.pharmacyTaxId,
          )?.prescriptions?.length > 0
        ) {
          const data = {
            status: "Pending",
            remark: "",
            prescription: getProcedureDetails(
              selectedProcedure?.serviceId ??
                selectedProcedure?.service?.serviceId,
              selectedProcedure?.variantId ??
                selectedProcedure?.variant?.variantId,
              selectedProcedure?.service?.name,
              services ?? [],
              clinicStocks ?? [],
              clinicDet?.pharmacyTaxId,
            )?.prescriptions,
            issue: "",
          };
          if (reqDet?.prescription?.[0]?.prescriptionId) {
            dispatch(
              updatePrescriptionByIdWoLoader({
                prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                data,
              }),
            );
          } else {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: appDet?.appointmentId,
                data,
              }),
            );
          }
        }
        const data = {
          procedureName: selectedProcedure?.service?.name,
          serviceId: selectedProcedure?.service?.serviceId,
          category: selectedProcedure?.service?.category,
          subCategory: selectedProcedure?.service?.subCategory,
          remarks: selectedProcedure?.service?.remarks,
          doneAt: moment(new Date()).format("YYYY-MM-DD"),
          status: "Pending",
          petId: appDet?.petId,
          appointmentId: appDet?.appointmentId,
          serviceCharge: selectedProcedure?.variant?.serviceCharge,
          serviceType: getOnlyName(selectedProcedure?.variant?.name),
          procedureDetails,
        };
        dispatch(createProcedureWoLoader({ data })).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
          }
        });
      }
    }
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    if (selectedItem?.type === "procedureDetail") {
      deleteProcedureDetailById(selectedItem?.item?.detailId);
    }
    if (selectedItem?.type === "presDetail") {
      deletePresDetailById(selectedItem?.item?.detailId);
    }
  };

  const getStockBatchForBilling = (stockId, batchId) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return null;
    const clinicBatches =
      reqStock?.stockBatch?.filter(
        (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
      ) ?? [];
    if (batchId) {
      return clinicBatches.find((bat) => bat?.batchId === batchId) ?? null;
    }
    const pharmacyBatch = clinicBatches.find((bat) => {
      const loc = locations?.find((l) => l?.id === bat?.locationId);
      return (
        (loc?.category ?? "").toLowerCase() === "pharmacy" &&
        Number(bat?.quantity ?? 0) > 0
      );
    });
    return pharmacyBatch ?? clinicBatches?.[0] ?? null;
  };

  const getIssuedProcedureDetails = () => {
    const list = [];
    reqDet?.procedures?.forEach((prcd) => {
      prcd?.procedureDetails?.forEach((det) => {
        if (det?.status === "issued") {
          const reqBat = getStockBatchForBilling(det?.stockId, det?.batchId);
          list.push({
            ...det,
            batchId: det?.batchId ?? reqBat?.batchId ?? null,
            batchNo: det?.batchNo ?? reqBat?.batchNo ?? null,
            procedureId: prcd?.procedureId,
            serviceId: det?.serviceId ?? prcd?.serviceId,
            source: "procedure",
            key: `proc-${det?.detailId}`,
            displayName: det?.name ?? det?.procedureName ?? "Issued item",
          });
        }
      });
    });
    return list;
  };

  const getCreateBillItems = () => {
    const dispensed = (dispensedBillItems ?? [])?.map((li, i) => {
      const reqBat = getStockBatchForBilling(
        li?.stockId,
        li?.batchId ?? li?.batchNumber?.value,
      );
      return {
        ...li,
        batchId:
          li?.batchId ?? li?.batchNumber?.value ?? reqBat?.batchId ?? null,
        batchNo:
          li?.batchNo ?? li?.batchNumber?.name ?? reqBat?.batchNo ?? null,
        source: "dispensed",
        key: `disp-${li?.detailId ?? li?.i ?? i}`,
        displayName:
          li?.plName ?? li?.name ?? li?.procedureName ?? "Dispensed item",
        quantity: Number(li?.qty ?? li?.quantity ?? 1),
      };
    });
    return [...dispensed, ...(getIssuedProcedureDetails() ?? [])];
  };

  const createBillItems = getCreateBillItems();
  const showCreateBill = createBillItems?.length > 0;

  const onOpenCreateBill = () => {
    const items = getCreateBillItems();
    setSelectedBillKeys(items?.map((li) => li?.key) ?? []);
    setCreateBillModVsble(true);
  };

  useEffect(() => {
    onCreateBillReady?.({
      show: showCreateBill,
      onOpen: onOpenCreateBill,
    });
  }, [showCreateBill, onCreateBillReady]);

  const onCloseCreateBillMod = () => {
    setCreateBillModVsble(false);
    setSelectedBillKeys([]);
  };

  const onToggleBillItem = (key, checked) => {
    if (checked) {
      setSelectedBillKeys((prev) => prev?.filter((k) => k !== key));
    } else {
      setSelectedBillKeys((prev) => [...(prev ?? []), key]);
    }
  };

  const onToggleSelectAllBillItems = (checked) => {
    if (checked) {
      setSelectedBillKeys([]);
    } else {
      setSelectedBillKeys(createBillItems?.map((li) => li?.key) ?? []);
    }
  };

  const buildBillingPayloadItem = (item) => {
    const stockId = item?.stockId ?? null;
    const batchId = item?.batchId ?? item?.batchNumber?.value ?? null;
    const reqStock = stockId
      ? clinicStocks?.find((stc) => stc?.stockId === stockId)
      : null;
    const reqBat = getStockBatchForBilling(stockId, batchId);
    const resolvedBatchId = batchId ?? reqBat?.batchId ?? null;
    const quantity = Number(item?.quantity ?? item?.qty ?? 1);
    const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
    const reqPercent = 100 + Number(taxPerent);
    const unitSelling = Number(reqBat?.unitSellingPrice ?? 0);
    const unitPrice = roundAmount(unitSelling / (reqPercent / 100 || 1));
    const taxValue = roundAmount((taxPerent / 100) * unitPrice * quantity);
    const total = roundAmount(unitSelling * quantity);
    const price = unitPrice;
    const mrpPrice = roundAmount(unitSelling);

    const base = {
      name:
        item?.displayName ??
        item?.name ??
        item?.plName ??
        item?.procedureName ??
        "",
      quantity,
      price,
      mrpPrice,
      tax: taxValue,
      total,
      discount: roundAmount(item?.discount ?? 0),
      mrpDiscount: roundAmount(item?.mrpDiscount ?? item?.discount ?? 0),
      discountType: item?.discountType ?? null,
      type:
        item?.type === "Consumables" || item?.type === "Administered"
          ? "product"
          : item?.stockId
            ? "product"
            : (item?.type ?? "product"),
      billType: item?.billType ?? billingTabEnum?.Pharmacy ?? "pharmacy",
      adminCharge: item?.adminCharge ?? "N",
      adminChargeAmount: roundAmount(item?.adminChargeAmount ?? 0),
      amtPaid: roundAmount(item?.amtPaid ?? 0),
      shortName: item?.shortName ?? reqStock?.shortName ?? null,
      linked: item?.linked ?? "N",
      autoConsumed: item?.autoConsumed ?? reqStock?.autoConsumed ?? false,
      patientWorkbook: item?.patientWorkbook ?? true,
      hsnSacCode: item?.hsnSacCode ?? null,
    };

    if (stockId) {
      return {
        ...base,
        stockId,
        batchId: resolvedBatchId,
        batchNo:
          item?.batchNo ?? item?.batchNumber?.name ?? reqBat?.batchNo ?? null,
        uomId: item?.uomId ?? null,
        uomName: item?.uomName ?? null,
        expiryDate: item?.expiryDate ?? reqBat?.expiryDate ?? null,
        drugSchedule: item?.drugSchedule ?? reqStock?.drugSchedule ?? null,
        packageUom: item?.packageUom ?? reqBat?.salesUom ?? null,
      };
    }

    return {
      ...base,
      serviceId: item?.serviceId ?? null,
      variantId: item?.variantId ?? item?.procedureVariantId ?? null,
      variantNumber: item?.variantNumber ?? null,
      procedureId: item?.procedureId ?? null,
    };
  };

  const onSubmitCreateBill = () => {
    const selectedItems = getCreateBillItems()?.filter((li) =>
      selectedBillKeys?.includes(li?.key),
    );
    if (!selectedItems?.length) return;

    const reqData = {
      type: "Pharmacy",
      paymentOption: "draft",
      direct: [],
      discountValue: 0,
      discountType: "percentage",
      referenceNo: "",
      estimate: false,
      checkOut: "N",
      userId: petDet?.userId ?? appDet?.userId,
      petId: petDet?.petId ?? appDet?.petId,
    };

    dispatch(addDirectBilling(reqData)).then((res) => {
      if (!res?.payload) return;
      const paymentId = res?.payload?.data;
      const reqList = selectedItems?.map((li) => buildBillingPayloadItem(li));
      dispatch(
        addBillingItemsToPaymentId({
          paymentId,
          data: reqList,
        }),
      ).then((addRes) => {
        if (addRes?.payload) {
          setCreateBillModVsble(false);
          setSelectedBillKeys([]);
          setDispensedBillItems([]);
          setSelecetdPayment({ paymentId, type: "Pharmacy" });
          setPosVisible(true);
        }
      });
    });
  };

  const handlePosBack = () => {
    setPosVisible(false);
    setSelecetdPayment(null);
    onApiCall();
  };

  if (posVisible && selectedPayment?.paymentId) {
    return (
      <PointOfSaleNew
        selectedPayment={selectedPayment}
        setSelecetdPayment={setSelecetdPayment}
        setActiveTab={handlePosBack}
        fromPharmacyProcedures
        onBack={handlePosBack}
      />
    );
  }

  return (
    <>
      <div className="mb20">
        {/* <div className="flex-row mh10 mt20">
          <div className="w25Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Procedure Name
            </Typography>
          </div>
          <div className="w25Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Variant
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Category
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Subcategory
            </Typography>
          </div>
          <div className="w10Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Service Charge
            </Typography>
          </div>
          <div className="w10Per" />
        </div>
        <div className="blue-hor-split mt5" />
        {procedures?.map((prcd, index) => {
          return (
            <div
              className="flex-row mt10 plan-bor"
              key={`procedure_${prcd?.procedureId ?? index}`}
            >
              <div className="w25Per pr10">
                <CustomSelect
                  list={getServiceList()}
                  value={prcd?.service?.name}
                  handleChange={(value) => onChange("service", value, prcd?.i)}
                  error={prcd?.servErr}
                  helperText={prcd?.servErr ? reqTxt : ""}
                  addNewSelect
                  searchOnly
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w25Per pr10">
                <CustomSelect
                  list={getVarinatList(prcd?.service?.serviceId)}
                  value={prcd?.variant?.name}
                  select
                  handleChange={(e) => {
                    onChange(
                      "variant",
                      getVarinatList(prcd?.service?.serviceId)?.find(
                        (li) => li?.name === e?.target?.value
                      ),
                      prcd?.i,
                      prcd?.variantId
                    );
                  }}
                  error={prcd?.varErr}
                  helperText={prcd?.varErr ? reqTxt : ""}
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.category}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.subCategory}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w10Per">
                <Typography className="font-medium fs12 mt10">
                  Rs. {Number(prcd?.variant?.servicePrice ?? 0)?.toFixed(2)}
                </Typography>
              </div>
              <div className="w10Per">
                {appDet?.checkOut !== "Y" ? (
                  <div className="flex1-end mt3">
                    <div className="flex-row-ali-cen">
                      {prcd?.editable ? (
                        <div
                          className="cursor"
                          onClick={() => createUpdateProcedure(prcd)}
                        >
                          <div className="flex-center">
                            <SaveIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Save
                          </Typography>
                        </div>
                      ) : null}
                      {!prcd?.editable ? (
                        <div
                          className="cursor ml10"
                          onClick={() => delProcedure(prcd?.i)}
                        >
                          <div className="flex-center">
                            <DeleteOutlineIcon sx={delBtn} />
                          </div>
                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                            Delete
                          </Typography>
                        </div>
                      ) : null}
                      {!prcd?.editable && (
                        <div
                          className="cursor ml10"
                          onClick={() => handleEditProcedure(prcd?.i)}
                        >
                          <div className="flex-center">
                            <EditIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Edit
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
        {appDet?.checkOut !== "Y" ? (
          <div className="flex-row-ali-cen mt10 cursor" onClick={addProcedure}>
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
        ) : null} */}
        {procedures?.length > 0 ? (
          <>
            <Card
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
                border: "1px solid #e0e0e0",
                backgroundColor: "#ffffff",
                overflow: "hidden",
                mt: 2.5,
              }}
            >
              <Box
                onClick={() => handleObjOpen("consum", !objOpen?.consum)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2.5,
                  py: 1.8,
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  userSelect: "none",
                  "&:hover": { backgroundColor: "#fafafa" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: AppColors.appPrimary,
                    fontSize: "16px",
                  }}
                >
                  Consumables (
                  {(procedValues?.consumList ?? [])?.filter(
                    (li) => !li?.isDelete,
                  )?.length ?? 0}
                  )
                </Typography>
                <IconButton size="small" sx={{ color: AppColors.appPrimary }}>
                  {objOpen?.consum ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                </IconButton>
              </Box>
              {objOpen?.consum ? (
                <Box px={2.5} pb={2.5} pt={1}>
                  <Box mb={2}>
                    {(procedValues?.consumList ?? [])
                      ?.filter((li) => !li?.isDelete)
                      ?.sort((a, b) => (a?.detailId ?? 0) - (b?.detailId ?? 0))
                      ?.map((li) => (
                        <PharmacyConsumableCard
                          key={li?.detailId ?? li?.i}
                          consumable={mapConsumListItemForCard(li)}
                          readOnly={appDet?.checkOut === "Y"}
                          batchOptions={getBatches(li?.stockId)}
                          onBatchChange={(value) =>
                            onChangeConsumValue("batchNumber", value, li?.i)
                          }
                          onIssue={handleIssueConsumItem}
                          onReject={handleRejectConsumItem}
                        />
                      ))}
                    {!procedValues?.consumList?.filter((li) => !li?.isDelete)
                      ?.length ? (
                      <Typography
                        sx={{ fontSize: "14px", color: "#9e9e9e", py: 2 }}
                      >
                        No consumables added yet.
                      </Typography>
                    ) : null}
                  </Box>
                  {appDet?.checkOut !== "Y" ? (
                    <>
                      {/* <Box
                        onClick={addNewConsumable}
                        sx={{
                          border: "1.5px dashed #90caf9",
                          borderRadius: "8px",
                          backgroundColor: "#f8faff",
                          py: 1.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            backgroundColor: "#eef4ff",
                            borderColor: AppColors.appPrimary,
                          },
                        }}
                      >
                        <Button
                          startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                          sx={{
                            color: AppColors.appPrimary,
                            fontWeight: 700,
                            fontSize: "14px",
                            textTransform: "none",
                            pointerEvents: "none",
                          }}
                        >
                          Add item
                        </Button>
                      </Box> */}
                      {canManagePharmacy && canIssueAllConsums ? (
                        <Box mt={2}>
                          <Typography
                            className="blu-back white-color fs14 font-medium con-fit pv5 ph15 br5 cursor"
                            onClick={onIssueAllConsums}
                          >
                            Issue All
                          </Typography>
                        </Box>
                      ) : null}
                    </>
                  ) : null}
                </Box>
              ) : null}
            </Card>

            <Card
              sx={{
                borderRadius: "8px",
                boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
                border: "1px solid #e0e0e0",
                backgroundColor: "#ffffff",
                overflow: "hidden",
                mt: 2.5,
              }}
            >
              <Box
                onClick={() => handleObjOpen("admin", !objOpen?.admin)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2.5,
                  py: 1.8,
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  userSelect: "none",
                  "&:hover": { backgroundColor: "#fafafa" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: AppColors.appPrimary,
                    fontSize: "16px",
                  }}
                >
                  Administer (
                  {(procedValues?.adminList ?? [])?.filter(
                    (li) => !li?.isDelete,
                  )?.length ?? 0}
                  )
                </Typography>
                <IconButton size="small" sx={{ color: AppColors.appPrimary }}>
                  {objOpen?.admin ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                </IconButton>
              </Box>
              {objOpen?.admin ? (
                <Box px={2.5} pb={2.5} pt={1}>
                  <Box mb={2}>
                    {(procedValues?.adminList ?? [])
                      ?.filter((li) => !li?.isDelete)
                      ?.sort((a, b) => (a?.detailId ?? 0) - (b?.detailId ?? 0))
                      ?.map((li) => (
                        <PharmacyAdministerCard
                          key={li?.detailId ?? li?.i}
                          item={mapAdminListItemForCard(li)}
                          readOnly={appDet?.checkOut === "Y"}
                          batchOptions={getBatches(li?.stockId)}
                          onBatchChange={(value) =>
                            onChangeAdminValue("batchNumber", value, li?.i)
                          }
                          onIssue={handleIssueAdminItem}
                          onReject={handleRejectAdminItem}
                        />
                      ))}
                    {!procedValues?.adminList?.filter((li) => !li?.isDelete)
                      ?.length ? (
                      <Typography
                        sx={{ fontSize: "14px", color: "#9e9e9e", py: 2 }}
                      >
                        No administered items added yet.
                      </Typography>
                    ) : null}
                  </Box>
                  {appDet?.checkOut !== "Y" ? (
                    <>
                      {/* <Box
                        onClick={addNewAdminister}
                        sx={{
                          border: "1.5px dashed #90caf9",
                          borderRadius: "8px",
                          backgroundColor: "#f8faff",
                          py: 1.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                          "&:hover": {
                            backgroundColor: "#eef4ff",
                            borderColor: AppColors.appPrimary,
                          },
                        }}
                      >
                        <Button
                          startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                          sx={{
                            color: AppColors.appPrimary,
                            fontWeight: 700,
                            fontSize: "14px",
                            textTransform: "none",
                            pointerEvents: "none",
                          }}
                        >
                          Add item
                        </Button>
                      </Box> */}
                      {canManagePharmacy && canIssueAllAdmins ? (
                        <Box mt={2}>
                          <Typography
                            className="blu-back white-color fs14 font-medium con-fit con-fit pv5 ph15 br5 cursor"
                            onClick={onIssueAllAdmins}
                          >
                            Issue All
                          </Typography>
                        </Box>
                      ) : null}
                    </>
                  ) : null}
                </Box>
              ) : null}
            </Card>
          </>
        ) : null}

        <Card
          sx={{
            borderRadius: "8px",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e0e0e0",
            backgroundColor: "#ffffff",
            overflow: "hidden",
            mt: 2.5,
          }}
        >
          <Box
            onClick={() => handleObjOpen("pres", !objOpen?.pres)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2.5,
              py: 1.8,
              cursor: "pointer",
              backgroundColor: "#ffffff",
              userSelect: "none",
              "&:hover": {
                backgroundColor: "#fafafa",
              },
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                color: AppColors.appPrimary,
                fontSize: "16px",
              }}
            >
              Prescription{" "}
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 400,
                  color: "#757575",
                  marginRight: "4px",
                }}
              >
                (take-home)
              </span>{" "}
              ({procedValues?.presList?.length ?? 0})
            </Typography>

            <IconButton size="small" sx={{ color: AppColors.appPrimary }}>
              {objOpen?.pres ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
            </IconButton>
          </Box>

          {objOpen?.pres ? (
            <Box px={2.5} pb={2.5} pt={1}>
              <Box mb={2}>
                {[...(procedValues?.presList ?? [])]
                  ?.sort(
                    (a, b) =>
                      (a?.id ?? a?.detailId ?? 0) - (b?.id ?? b?.detailId ?? 0),
                  )
                  ?.map((pr) => (
                    <PharmacyPrescriptionCard
                      key={pr?.detailId ?? pr?.i}
                      item={pr}
                      readOnly={appDet?.checkOut === "Y"}
                      onDispense={handleDispensePresItem}
                    />
                  ))}
                {!procedValues?.presList?.length ? (
                  <Typography
                    sx={{ fontSize: "14px", color: "#9e9e9e", py: 2 }}
                  >
                    No take-home medications prescribed yet.
                  </Typography>
                ) : null}
              </Box>

              {appDet?.checkOut !== "Y" ? (
                <>
                  {/* <Box
                    onClick={handleAddNewPres}
                    sx={{
                      border: "1.5px dashed #90caf9",
                      borderRadius: "8px",
                      backgroundColor: "#f8faff",
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#eef4ff",
                        borderColor: AppColors.appPrimary,
                      },
                    }}
                  >
                    <Button
                      startIcon={<AddIcon sx={{ fontSize: 20 }} />}
                      sx={{
                        color: AppColors.appPrimary,
                        fontWeight: 700,
                        fontSize: "14px",
                        textTransform: "none",
                        pointerEvents: "none",
                      }}
                    >
                      Add medication
                    </Button>
                  </Box> */}

                  {canManagePharmacy &&
                  (procedValues?.presList ?? [])?.some(
                    (li) =>
                      typeof li?.itemIssued !== "boolean" &&
                      li?.isEdit !== false,
                  ) ? (
                    <Box mt={2}>
                      <Typography
                        className="blu-back white-color fs14 font-medium con-fit cursor pv5 ph15 br5 cursor"
                        onClick={onDispenseAllPres}
                      >
                        Dispense All
                      </Typography>
                    </Box>
                  ) : null}
                </>
              ) : null}
            </Box>
          ) : null}
        </Card>
        {/* <div className="mt20 flex-row-ali-cen">
          <Typography className="font-bold fs14 blue-color">Notes</Typography>
          {appDet?.checkOut !== "Y" ? (
            <div
              className="flex-row-ali-cen cursor flex1-end"
              onClick={onAddNotes}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={addIcon} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div>
          ) : null}
        </div>
        <Typography className="mt5 mb10 font-medium fs12 black">
          {appDet?.notes}
        </Typography> */}
      </div>

      <CustomModal
        open={conStatusVsble}
        onClose={onCloseConMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={consumValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangeConStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveConsumStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admStatusVsble}
        onClose={onCloseAdmMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={adminValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangeAdminStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveAdminStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={presStatusVsble}
        onClose={onClosePresMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonIssueList}
            value={presValues?.itemIssuedStatus}
            select
            handleChange={(e) =>
              onChangePresStatusValue("itemIssuedStatus", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={handleSavePresStatus} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={notesModVsble}
        onClose={onCloseNoteMod}
        header="Notes"
        modal
        modalWidth={40}
        headerShown={true}
      >
        <div className="ph10">
          <CustomTextField
            value={notes}
            handleChange={(e) => setNotes(e?.target?.value)}
            multiline
            fullWidth
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={onSaveNotes} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admUpdteModVsble}
        onClose={onCloseAdmUpdteMod}
        header="Administer"
        rightModal
        modalWidth={30}
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Name</div>
              <CustomSelect
                list={
                  adminValues?.fromService
                    ? getDropList(adminValues)
                    : getList(true)
                }
                value={adminValues?.name}
                addNewSelect
                mandatoryField
                handleChange={(e) => {
                  onChangeAdminModValue("name", e?.value ?? e, {
                    stockId: e?.stockId ?? null,
                    productId: e?.productId ?? null,
                    serviceId: e?.serviceId ?? null,
                    type: e?.type,
                  });
                }}
                plusBtn
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Batch Number</div>
              <CustomSelect
                list={getBatches(adminValues?.stockId)}
                value={adminValues?.batchNumber}
                handleChange={(e, value) => {
                  onChangeAdminModValue("batchNumber", value);
                }}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Dose</div>
              <CustomTextField
                fullWidth
                handleChange={(e) =>
                  onChangeAdminModValue("dosage", e?.target?.value)
                }
                value={adminValues?.dosage}
                suffix={
                  getRightPackageUom(
                    getBatch(
                      adminValues?.stockId,
                      adminValues?.batchNumber?.value ?? adminValues?.batchId,
                    )?.packageUom,
                  )?.length > 0 ? (
                    <Custom3dotString
                      str={`${getRightPackageUom(
                        getBatch(
                          adminValues?.stockId,
                          adminValues?.batchNumber?.value ??
                            adminValues?.batchId,
                        )?.packageUom,
                      )}`}
                      length={9}
                      className="fs12 font-medium"
                    />
                  ) : (
                    ""
                  )
                }
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Route</div>
              <CustomSelect
                list={routeList}
                value={adminValues?.route}
                search
                handleChange={(e, value) => {
                  onChangeAdminModValue("route", value);
                }}
              />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Link to Procedure
              </div>
              <CustomSelect
                list={getProcedureListAsDrop()}
                value={adminValues?.linkToProcedure}
                select
                handleChange={(e) => {
                  const reqPrcd = getProcedureListAsDrop()?.find(
                    (li) => li?.name === e?.target?.value
                  );
                  onChangeAdminModValue("linkToProcedure", e?.target?.value, {
                    serviceId: reqPrcd?.serviceId,
                    variantId: reqPrcd?.variantId,
                    procedureId: reqPrcd?.procedureId,
                  });
                }}
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="txt-semi-bold fs14 light-grey">Status </div>
                {typeof adminValues?.itemIssued === "boolean" ? (
                  <Typography
                    className={`${
                      adminValues?.itemIssued ? "green-back5" : "red-back2"
                    } white-color status-con fs12 font-medium ml15`}
                  >
                    {adminValues?.itemIssued ? "Issued" : "Rejected"}
                  </Typography>
                ) : null}
              </div>
              <div className="mt5">
                <CustomSelect
                  list={pharmacyStatusDrop}
                  value={adminValues?.itemIssued}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("itemIssued", e?.target?.value)
                  }
                />
              </div>
            </Grid>
            {typeof adminValues?.itemIssued === "boolean" &&
            !adminValues?.itemIssued ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">Reason</div>
                <CustomSelect
                  list={reasonIssueList}
                  value={adminValues?.itemIssuedStatus}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("itemIssuedStatus", e?.target?.value)
                  }
                />
              </Grid>
            ) : null}
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Save" smallBtn onClick={onSaveAdminValues} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={fileValues?.modVsble}
        onClose={onCloseFileMod}
        header="Files"
        modal
        modalWidth={40}
      >
        <div className="ph20 scroll-50vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {fileValues?.files?.length > 0 ? (
                <FilesWithCloseButton
                  files={fileValues?.files}
                  onClickFile={(i, file) => handleRemoveFile(i)}
                />
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadFiles}
                multipleNew
                multiFiles
                fileAccept="image/*,.pdf"
              />
            </Grid>
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Upload" smallBtn onClick={onFilesApiCall} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={changeWarnVsble}
        onClose={onCloseChangeWarnMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            All changes will be lost. Are you sure you want to continue?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmChangeWarn}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseChangeWarnMod} />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-center">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Are you sure you want to delete this record?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmDelete}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseDelMod} />
          </div>
        </div>
      </CustomModal>

      <PharmacyAddConsumablesDrawer
        open={isAddConsumDrawerOpen}
        onClose={() => setIsAddConsumDrawerOpen(false)}
      />

      <PharmacyEditConsumableDrawer
        open={isEditConsumDrawerOpen}
        onClose={() => {
          setIsEditConsumDrawerOpen(false);
          setSelectedConsumable(null);
        }}
        consumable={selectedConsumable}
      />

      <PharmacyAddAdministerDrawer
        open={isAddAdminDrawerOpen}
        onClose={() => setIsAddAdminDrawerOpen(false)}
      />

      <PharmacyEditAdministerDrawer
        open={isEditAdminDrawerOpen}
        onClose={() => {
          setIsEditAdminDrawerOpen(false);
          setSelectedAdminItem(null);
        }}
        item={selectedAdminItem}
      />

      <AddPrescriptionDrawer
        open={isAddPresDrawerOpen}
        onClose={() => setIsAddPresDrawerOpen(false)}
      />

      <EditPrescriptionDrawer
        open={isEditPresDrawerOpen}
        onClose={() => {
          setIsEditPresDrawerOpen(false);
          setSelectedPresItem(null);
        }}
        item={selectedPresItem}
      />

      <CustomModal
        open={createBillModVsble}
        onClose={onCloseCreateBillMod}
        header="Create Bill"
        modal
        modalWidth={40}
        headerShown={true}
      >
        <div className="ph10">
          {createBillItems?.length > 0 ? (
            <>
              <div className="flex-row-ali-cen mb10">
                <CustomCheckbox
                  checked={
                    createBillItems?.length > 0 &&
                    selectedBillKeys?.length === createBillItems?.length
                  }
                  onChange={onToggleSelectAllBillItems}
                  label="Select All"
                />
              </div>
              <div className="scroll-70vh">
                {createBillItems?.map((li) => (
                  <div key={li?.key} className="flex-row-ali-cen ml5">
                    <CustomCheckbox
                      checked={selectedBillKeys?.includes(li?.key)}
                      onChange={(checked) => onToggleBillItem(li?.key, checked)}
                      label={`${li?.displayName ?? ""} (Qty: ${li?.quantity ?? li?.qty ?? 1})${
                        li?.source === "dispensed"
                          ? " — Dispensed"
                          : " — Issued"
                      }`}
                    />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <Typography className="fs14 font-medium text-align-center mv20">
              No items available
            </Typography>
          )}
          <div className="flex-center mt20 mb10">
            <div>
              <CustomButton
                text="Submit"
                smallBtn
                onClick={onSubmitCreateBill}
                disabled={!selectedBillKeys?.length}
              />
            </div>
            <div className="ml20">
              <CustomButton
                text="Cancel"
                smallBtn
                onClick={onCloseCreateBillMod}
                redBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetPharmacyProcedures;
